import React , {useEffect, useState} from "react";
import { flushSync } from "react-dom";
import { Page, Text, View, Document, StyleSheet, Image, Font, Link,pdf, Line } from '@react-pdf/renderer';
//import ReactDOM from 'react-dom';
import { PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";
import LinearProgress from "@material-ui/core/LinearProgress";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";


// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import ImageUpload from "components/CustomUpload/ImageUpload.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";


import logo from "assets/img/logo2.png";
import mark from "assets/img/panel.png";
import default_geocode from "assets/img/default_geocode.png";


import {  Redirect, useParams } from "react-router-dom";

import axios from 'axios'

import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";

import Font_ from "assets/Urbanist-Light.ttf";
import { PUBLIC_FIGURES, PUBLIC_SIGNS, PUBLIC_STATUS, STATUS_1_IMAGE, STATUS_2_IMAGE, STATUS_3_IMAGE, STATUS_4_IMAGE, STATUS_6_IMAGE, TOC_IMAGE, Section_IMAGE } from "../../constants";

const useStyles = makeStyles(styles);

export default function NewUser() {

    const {id} = useParams();

    const {type} = useParams();


    const [report, setreport] = React.useState([]);
    const [token_logged, settoken_logged] = React.useState("");
    const [redirctTo, setRedirctTo] = useState(false);
    const [redirctTo_new_user, setRedirctTo_new_user] = useState(false);
    const [tc, setTC] = React.useState(false);

    const [redirctTo_all, setRedirctTo_all] = useState(false);
    const [RedirctTo_images, setRedirctTo_images] = useState(false);
    const [Errmessage, setErrmessage] = React.useState("");
    const [reportDownloaded, setReportDownloaded] = useState(false);

    const [image_cover, setimage_cover] = React.useState("");
    const [image_cover_b64, setimage_cover_b64] = React.useState("");

    const [sections, setsections] = React.useState([]);
    const [s_total, sets_total] = React.useState([]);

    const [r_type, setr_type] = React.useState(type);
    

    const [report_date, setreport_date] = React.useState("");
    const [sub_case, setsub_case] = React.useState("");
    
    // Progress bar state
    const [processingProgress, setProcessingProgress] = React.useState(0);
    const [processingStatus, setProcessingStatus] = React.useState("");
    const [showProgress, setShowProgress] = React.useState(false);
    const [processingStartTime, setProcessingStartTime] = React.useState(null);

    const [indice, setindice] = React.useState([]);

    const [text2, settext2] = React.useState("");
    const [textColor, setTextColor] = React.useState("#00af0b");

    const [text3, settext3] = React.useState(""); // text for Compliant and not Non-Compliant  
    
    // PDF caching states
    const [cachedPdfUrl, setCachedPdfUrl] = React.useState("");
    const [isLoadingCachedPdf, setIsLoadingCachedPdf] = React.useState(false);
    const [pdfCacheError, setPdfCacheError] = React.useState("");
    const [showCachedPdf, setShowCachedPdf] = React.useState(false);
    const [pdfGenerationProgress, setPdfGenerationProgress] = React.useState(0);
    const [pdfGenerationStatus, setPdfGenerationStatus] = React.useState("");
    const [cachedImages, setCachedImages] = React.useState({});

    //const image_url = "http://localhost:5000/public/";
   

    const image_url_s = PUBLIC_SIGNS;

    const image_url_f = PUBLIC_FIGURES;

    // Helper function to construct Firebase URL using environment variables
    const getFirebaseImageUrl = (imageName) => {
      // Use production Firebase bucket (without REACT_APP prefix) for images
      const bucketUrl = process.env.FIREBASE_BUCKET_URL || "https://firebasestorage.googleapis.com/v0/b/arcorapp.appspot.com/o/images%2F";
      const token = process.env.REACT_APP_FIREBASE_TOKEN || "6bf3ba62-0825-4527-a9e6-2215c0ca1901";
      const url = `${bucketUrl}${imageName}?alt=media&token=${token}`;
      console.log(`Firebase URL construction: ${imageName} -> ${url}`);
      return url;
    };





  
  React.useEffect(() => {
    let text = "";
    if(r_type == 1){
      text = "Now Viewing Compliant Report";
      setTextColor("#00af0b");
      settext2("Compliant");
    }else{
      text = "Now Viewing Non-Compliant Report";
      setTextColor("#ef0000") ;
      settext2("Non-Compliant");
    }

    
    document.getElementById("test_id").innerHTML = text;


      const local_login = localStorage.getItem('local_login')
      let token = "";
      if(local_login){
        try {
        const getToken = async () => {
          const res = await axios.post('/user/refresh_token', null)
          
          token = res.data.access_token;

          settoken_logged(token);

          const res2 = await axios.get('/user/infor', {
            headers: {Authorization: token}
          })     
          // console.log( res2.data );

          const res3 = await axios.post('/codeset/info_report', {id},{
            headers: {Authorization: token}
          })
          let codes_show = []
          // console.log(res3.data);
          // console.log(res3.data.report[0].length);
          let report_ = {};
          // console.log(res3.data.report_type);

          console.log("=== API Response Debug ===");
          console.log("report_type:", res3.data.report_type);
          console.log("long_report1 type:", typeof res3?.data?.long_report1);
          console.log("long_report1 length:", res3?.data?.long_report1?.length);
          console.log("report type:", typeof res3?.data?.report);
          console.log("report is array:", Array.isArray(res3?.data?.report));
          console.log("=== End API Response Debug ===");

          if(res3.data.report_type == 2){
            // Fix: Add proper parentheses to concatenate strings before parsing
            const longReport = (res3?.data?.long_report1 || "") + (res3?.data?.long_report2 || "");
            try {
              report_ = JSON.parse(longReport);
            } catch (parseError) {
              console.error("Failed to parse long report JSON:", parseError);
              console.error("JSON string length:", longReport.length);
              console.error("Parse error position:", parseError.message);
              // Set empty report structure to prevent cascading errors
              report_ = { sections: [], signs: [] };
              alert("Error loading report data. The report may be corrupted. Please contact support.");
            }
          }else{
            try {
              report_ = JSON.parse(res3?.data?.report || "{}");
            } catch (parseError) {
              console.error("Failed to parse report JSON:", parseError);
              report_ = { sections: [], signs: [] };
              alert("Error loading report data. The report may be corrupted. Please contact support.");
            }
          }
          
          //let report_ = {};
          // console.log( report_ );
          
          // console.log( res3.data.createdAt );
          let date = new Date(res3?.data?.createdAt);
          /* Date format you have */
          let monthNames =["Jan","Feb","Mar","Apr",
                            "May","Jun","Jul","Aug",
                            "Sep", "Oct","Nov","Dec"];
          let monthIndex = date.getMonth();
          let monthName = monthNames[monthIndex];
          let dateMDY = `${monthName} ${date.getDate()} ${date.getFullYear()}`;

          setreport_date(dateMDY);

          // Debug report structure
          console.log("=== Report Structure Debug ===");
          console.log("report_ keys:", Object.keys(report_ || {}));
          console.log("report_.signs exists:", !!report_?.signs);
          console.log("report_.signs length:", report_?.signs?.length || 0);
          console.log("report_.sections exists:", !!report_?.sections);
          console.log("report_.sections length:", report_?.sections?.length || 0);
          console.log("s_total:", s_total);
          console.log("=== End Report Structure Debug ===");
          
          // Performance warning for large reports and progress setup
          const estimatedItems = (report_?.sections?.length || 0) * 10; // rough estimate
          const totalSections = report_?.sections?.length || 0;
          const isLargeReport = estimatedItems > 200 || totalSections >= 8; // Lower threshold and include 8
          
          console.log("=== Progress Bar Condition Debug ===");
          console.log("estimatedItems:", estimatedItems);
          console.log("totalSections:", totalSections);
          console.log("estimatedItems > 200:", estimatedItems > 200);
          console.log("totalSections >= 8:", totalSections >= 8);
          console.log("isLargeReport:", isLargeReport);
          
          if (isLargeReport) {
            console.log("⚠️ LARGE REPORT DETECTED: This report may take longer to process due to size");
            console.log(`Estimated items: ${estimatedItems}+ (actual sections: ${totalSections})`);
            
            console.log("✅ Large report detected - progress bar will be shown when processing starts");
          } else {
            console.log("❌ Progress bar disabled - report too small");
          }
          console.log("=== End Progress Bar Debug ===");

          // Merge signs from API response if not in parsed report
          if (!report_?.signs) {
            console.log("WARNING: No signs in parsed report, using top-level signs from API");
            report_.signs = res3.data.signs || [];
          }

          setreport(report_)

          let sings_total = [];

          for (let f = 0; f < (report_?.signs?.length || 0); f++) {
            let item = {}
            item.name = report_.signs[f].name;
            // Signs are stored on Heroku server, not Firebase - keep original URL
            item.image = report_.signs[f].image;
            item.sign_cost = report_.signs?.[f]?.sign_cost;
            item.sign_labor = report_.signs?.[f]?.sign_labor;
            item.count = 0;
            sings_total.push(item)
            // console.log("test abcd",image_url_s)
          }

          console.log("=== Initial Signs Setup ===");
          console.log("report_.signs length:", report_?.signs?.length || 0);
          console.log("sings_total array:", sings_total);
          console.log("=== End Initial Signs Setup ===");

          for (let f = 0; f < (report_?.signs?.length || 0); f++) {
            // Signs are stored on Heroku server, not Firebase - keep original URL
            // No conversion needed, signs already have correct Heroku URLs
            if (report_?.signs?.[f]) {
              // Keep the original image URL as-is
              report_.signs[f].image = report_.signs[f].image;
            }
          }

          var photo_id = 1;

          let all_images =  [];

          for (let i = 0; i < report_?.sections?.length; i++) {
            for (let l = 0; l < report_.sections[i].photos_gallery.length; l++) {
              all_images.push(report_.sections[i].photos_gallery[l]);
            }  
          }

          console.log("=== Image Processing Debug ===");
          console.log("all_images length:", all_images.length);
          console.log("r_type (report type):", r_type);
          if(all_images.length > 0) {
            console.log("Sample image object:", all_images[0]);
            console.log("Sample image upload_name:", all_images[0].upload_name);
            console.log("Sample image UUID:", all_images[0].uuid);
            console.log("Sample Firebase URL:", getFirebaseImageUrl(all_images[0].upload_name));
            console.log("All available image UUIDs:", all_images.map(img => img.uuid));
          }
          console.log("=== End Image Processing Debug ===");

          
          // For very large reports, we'll process in smaller chunks to prevent browser blocking
          const isVeryLargeReport = (report_?.sections?.length || 0) > 10;
          if (isVeryLargeReport) {
            console.log("🚀 PERFORMANCE MODE: Processing large report with optimized chunking");
          }

          console.log("=== Starting Section Processing ===");
          console.log("showProgress:", showProgress);
          console.log("totalSections:", totalSections);
          console.log("sections length:", report_?.sections?.length || 0);
          
          // Initialize progress bar right before processing starts
          const shouldShowProgress = isLargeReport;
          if (shouldShowProgress) {
            console.log("🚀 Initializing progress bar for processing...");
            flushSync(() => {
              setShowProgress(true);
              setProcessingStartTime(Date.now());
              setProcessingStatus(`Initializing report with ${totalSections} sections...`);
              setProcessingProgress(5); // 5% for initialization
            });
            console.log("✅ Progress bar initialized and shown");
          }

          console.log("=== Starting Code Reference Processing ===");
          console.log("r_type:", r_type);
          console.log("report_.is_cheked_active:", report_?.is_cheked_active);
          let totalCodeRefsProcessed = 0;
          let totalCodeRefsIncluded = 0;

          for (let i = 0; i < (report_?.sections?.length || 0); i++) {
            // Update progress for large reports using local variable
            if (shouldShowProgress && i % 1 === 0) { // Update progress every section
              const sectionProgress = Math.round(((i + 1) / totalSections) * 80) + 10; // 10-90% for section processing
              const elapsedTime = Date.now() - processingStartTime;
              const estimatedTotal = (elapsedTime / (i + 1)) * totalSections;
              const eta = Math.max(0, Math.round((estimatedTotal - elapsedTime) / 1000));
              
              console.log(`🔄 Progress Update: Section ${i + 1}/${totalSections}, Progress: ${sectionProgress}%, ETA: ${eta}s`);
              
              // Force immediate React state update and DOM sync
              flushSync(() => {
                setProcessingProgress(sectionProgress);
                setProcessingStatus(
                  `Processing section ${i + 1} of ${totalSections}${eta > 0 ? ` (ETA: ${eta}s)` : ''}`
                );
                // Ensure showProgress stays true during processing
                setShowProgress(true);
              });
            }
            
            let first = 0;
              for (let j = 0; j < report_?.sections?.[i]?.sections.length; j++) {              
                for (let k = 0; k < report_?.sections?.[i]?.sections?.[j]?.code_references.length; k++) {

                  let show = 1;
                  if(report_?.is_cheked_active){
                    // console.log("enter here ooooo");
                    if(report_.is_cheked_active == 1 && report_.sections[i].view_checked === true){
                      show = 1;
                    }else{
                      show = 0;
                    }
                  }                

                  totalCodeRefsProcessed++;
                  if(show == 1){
                const currentStatus = report_.sections[i].sections[j].code_references[k].status;
                const isNonCompliantItem = r_type == 2 && (currentStatus == 2 || currentStatus == 3 || currentStatus == 4 || currentStatus == 5);
                const isCompliantItem = r_type == 1 && (currentStatus == 1 || currentStatus == 6);

                console.log(`Code Ref [${i}][${j}][${k}]: status=${currentStatus}, r_type=${r_type}, show=${show}, isNonCompliant=${isNonCompliantItem}, isCompliant=${isCompliantItem}`);

                if(isNonCompliantItem || isCompliantItem) {
                  totalCodeRefsIncluded++;

                  report_.sections[i].sections[j].code_references[k].section_name_show = report_.sections[i].sections[j].section_name;
                  if(first == 0){
                    report_.sections[i].sections[j].code_references[k].section_principal_t = 1;
                    report_.sections[i].sections[j].code_references[k].section_principal = report_.sections[i].section_name;
                    report_.sections[i].sections[j].code_references[k].section_name_real = report_.sections[i].sections[j].section_name;
                    report_.sections[i].sections[j].code_references[k].section_principal_sub_1 = 0;
                    if(report_.sections[i].section_subname){
                      report_.sections[i].sections[j].code_references[k].section_principal_sub_1 = 1;
                    }
                    report_.sections[i].sections[j].code_references[k].section_principal_sub = report_.sections[i].section_subname;
                    first = 1;
                  }else{
                    report_.sections[i].sections[j].code_references[k].section_principal_t = 0;
                    report_.sections[i].sections[j].code_references[k].section_principal = report_.sections[i].section_name;
                    report_.sections[i].sections[j].code_references[k].section_name_real = report_.sections[i].sections[j].section_name;
                  }                

                  
                  codes_show.push(report_.sections[i].sections[j].code_references[k]);  
                  
                  

                  report_.sections[i].sections[j].code_references[k].photos_added_show = [];

                  // Debug photo matching process
                  const codeRef = report_.sections[i].sections[j].code_references[k];
                  console.log(`\n=== Photo Processing for Code Reference ${codeRef.reference} ===`);
                  console.log(`Status: ${currentStatus}, Photos added UUIDs:`, codeRef.photos_added);
                  console.log(`Available images count: ${all_images.length}`);

                  for (let l = 0; l < all_images.length; l++) {
                    if(codeRef.photos_added.includes(all_images[l].uuid)){
                      console.log(`✅ Match found! UUID: ${all_images[l].uuid}, Name: ${all_images[l].upload_name}`);
                      codeRef.photos_added_show.push( { "name": all_images[l].upload_name, "photo_id": photo_id } )
                      photo_id++;
                    }
                  }

                  console.log(`Final photos_added_show count: ${codeRef.photos_added_show.length}`);
                  console.log(`=== End Photo Processing ===\n`);  
                  report_.sections[i].sections[j].code_references[k].figures_added_show = [];  
                  
                  for (let s = 0; s < report_.sections[i].sections[j].code_references[k].figures_added.length; s++) {
                    if(report_.sections[i].sections[j].code_references[k].figures_added[s].status){
                      report_.sections[i].sections[j].code_references[k].figures_added_show.push(report_.sections[i].sections[j].code_references[k].figures_added[s])
                    }
                  }       


                  console.log(`Signs for Code Ref [${i}][${j}][${k}]:`, report_.sections[i].sections[j].code_references[k].signs_added);
                  for (let f = 0; f < (report_?.signs?.length || 0); f++) {
                    if(report_.sections[i].sections[j].code_references[k].signs_added[f] > 0){
                      console.log(`✅ Incrementing sign[${f}] count: ${report_.sections[i].sections[j].code_references[k].signs_added[f]}`);
                      sings_total[f].count++
                    }
                  }

                }
                }

                
                
              }
            }
          }

          console.log("=== Code Reference Processing Summary ===");
          console.log("Total code refs processed:", totalCodeRefsProcessed);
          console.log("Total code refs included (passed filters):", totalCodeRefsIncluded);
          console.log("=== End Code Reference Processing ===");

          // console.log(sings_total);
          sets_total(sings_total);
          console.log("=== Final s_total Array ===");
          console.log("s_total populated:", sings_total);
          console.log("Signs with count > 0:", sings_total.filter(s => s.count > 0));
          console.log("=== End Final s_total Array ===");

          if(report_.cover_type == 'google'){
            setimage_cover(getFirebaseImageUrl(report_.cover_url_upload));
          }
          if(report_.cover_type == 'camera'){
            setimage_cover(getFirebaseImageUrl(report_.cover_url_upload));
          }

          if(report_.subcasenumber != ""){
            setsub_case("Sub Case #" + report_.subcasenumber)
          }

          



          codes_show.forEach(item => {
            // Filter out comments with status true
            item.comments_added = item.comments_added.filter(comment => comment.status === true);
        
            // Filter out recommendations with status true
            item.recommendations_added = item.recommendations_added.filter(recommendation => recommendation.status === true);
        });

          codes_show.sort((a, b) => a.section_principal.localeCompare(b.section_principal))


          var conunt1 = 0;
          var conunt2 = 0;
          var actual_section = "";

          let indice_show = []

          let new_photo_id = 1;

          for (let i = 0; i < codes_show.length; i++) {
            if(codes_show[i].section_principal_t == 1){
              // console.log(codes_show[i].section_principal);
              if(actual_section != codes_show[i].section_principal){
                conunt1++;
                actual_section = codes_show[i].section_principal
                codes_show[i].section_principal = conunt1 + ": " + codes_show[i].section_principal                
                conunt2 = 1;
              }else{
                conunt2++;
                actual_section = codes_show[i].section_principal
                codes_show[i].section_principal = conunt1 + "." + conunt2 + ": " + codes_show[i].section_principal
                
              }
              indice_show.push([codes_show[i].section_principal,codes_show[i].nameid ]);
            }
            
            for (let l = 0; l < codes_show[i].photos_added_show.length; l++) {
              codes_show[i].photos_added_show[l].photo_id = new_photo_id;
              new_photo_id++;
            }
          }

          setindice(indice_show)
          setsections(codes_show)

          // Final debug summary
          console.log("=== Final Report Summary ===");
          console.log(`Report Type: ${r_type} (${r_type == 1 ? 'Compliant' : 'Non-Compliant'})`);
          console.log(`Total sections processed: ${codes_show.length}`);
          const sectionsWithImages = codes_show.filter(section => section.photos_added_show && section.photos_added_show.length > 0);
          console.log(`Sections with images: ${sectionsWithImages.length}`);
          sectionsWithImages.forEach(section => {
            console.log(`  - ${section.reference}: ${section.photos_added_show.length} photos`);
          });
          console.log("=== End Final Report Summary ===");
          
          // Complete progress bar using local variable
          if (shouldShowProgress) {
            console.log("🎉 Completing progress bar - showing 100%");
            flushSync(() => {
              setProcessingProgress(100);
              setProcessingStatus(`Report completed! Processed ${totalSections} sections.`);
            });
            
            // Hide progress bar after a brief completion display
            setTimeout(() => {
              setShowProgress(false);
              setProcessingProgress(0);
              setProcessingStatus("");
            }, 2000);
          }

          
        }
        getToken()
          } catch (err) {
            setRedirctTo(true);
        }
      }else{
        setRedirctTo(true)
      }

          
  }, r_type);
  


  const classes = useStyles();

  if (redirctTo){
    return <Redirect to='/auth/login-page'  />
  }

  if (redirctTo_new_user){
    return <Redirect to={'/admin/reports/'}  />
  }

  if (RedirctTo_images){
    return <Redirect to={'/admin/images/' + id}  />
  }

  


   // Create styles
  const styles = StyleSheet.create({
    page: {
      flexDirection: 'column',
      backgroundColor: '#FFFFFF',
      paddingTop: 20,
      paddingBottom: 65,
      paddingHorizontal: 20,
      fontSize: "9px",
      fontFamily: 'Helvetica',
    },
    section: {
      fontSize: "9px",
      fontWeight: "light",
      width: "25%",
    },
    section_title: {
      textAlign: "center",
      fontWeight: "bold",
      fontSize: "9px",
      fontFamily: 'Helvetica'
    },
    title_text: {
      fontSize: "9px", 
      textAlign: "center",
      alignSelf: "center",
      fontFamily: 'Helvetica'
    },
    section_logo: {
      textAlign: "right",   
      alignContent: "flex-end",
      width: "25%",
      fontFamily: 'Helvetica'
    },
    p_text: {
      fontSize: "10px", 
      textAlign: "justify",
      paddingTop: 10,
      fontFamily: 'Helvetica'
    },
    code_header: {
      flexDirection: 'row',
      backgroundColor: "#224B8B",
      color: "white",
      padding: "10px 10px",
      fontSize: "16px",
      marginBottom: "15px",
      textAlign: "center",
      border:"2px solid #000"
    },
    code_header_sub: {
      flexDirection: 'row',
      backgroundColor: "#4EBCFC",
      color: "white",
      padding: "10px 10px",
      fontSize: "16px",
      borderLeft:"1px solid #000",
      borderRight:"1px solid #000",
      borderTop:"1px solid #000"
    },
    code_header2: {
      flexDirection: 'row',
      backgroundColor: "#000",
      color: "white",
      padding: "10px 10px",
      fontSize: "16px"
    },
    pageNumber: {
      position: 'absolute',
      fontSize: 11,
      bottom: 30,
      left: 0,
      right: 0,
      textAlign: 'center',
      color: 'grey',
    },
    pageNumber2: {
      position: 'absolute',
      fontSize: 11,
      bottom: 30,
      left: 0,
      right: 0,
      textAlign: "right",
      color: 'grey',
      paddingRight: "15px"
    },
    flexDirectionRow:{flexDirection: "row"},
    commonColumn:{
      flexDirection: "column", borderTop: "1px solid #000", borderLeft: "1px solid #000", borderBottom: "1px solid #000",fontSize: 11, fontFamily: 'Helvetica',padding: "10px 5px 10px 5px",
      width: "30%"
    },
    w30:{width: "30%"},
    wrapWord:{flexDirection:"row",flexWrap:"wrap", },

    // new styles that are added

   report_header:{
      flexDirection: 'row',
      fontFamily: 'Helvetica-Bold',
      //backgroundColor: "#03045E",
      backgroundColor: "#224B8B",
      color: "white",
      padding: "10px 10px",
      fontSize: "14",
      marginTop: "10px",
      textAlign: "center",
      border:"1px solid #000",
      fontWeight:"bold"
    },
    report_text:{
      borderBottom: '1px solid #000',
      borderLeft: '1px solid #000',
      borderRight: '1px solid #000',
      borderBottomColor: 'black', // Green bottom border
      borderLeftColor: 'black', // Blue left border
      borderRightColor:'black',
      width:'100%',
      flexDirection: 'column', //  column to properly stack rows
      alignContent: 'center',
      textAlign: 'left',
      padding: '5px 5px 5px 5px',
    },
    bullet: {
      fontFamily: 'Helvetica-Bold',
      fontSize: 14,
    },
    code_header_sub_border: {
      flexDirection: 'row',
      backgroundColor: "#4EBCFC",
      color: "white",
      padding: "10px 10px",
      fontSize: "16px",
      border:"1px solid #000",
    },
    code_header_sub_bottom: {
      flexDirection: 'row',
      backgroundColor: "#4EBCFC",
      color: "white",
      padding: "10px 10px",
      fontSize: "16px",
      borderLeft:"1px solid #000",
      borderRight:"1px solid #000",
      borderBottom:"1px solid #000"
    },
    linkText: {
      color: 'blue', 
      textDecoration: 'underline', // Underline the link text
      cursor: 'pointer', // Show a pointer cursor on hover
    },
    pageNumber1: {
      position: 'absolute',
      fontSize: 11,
      bottom: 30,
      left: 0,
      right: 0,
      textAlign: "left",
      color: 'grey',
      paddingLeft: "15px"
    },
    textContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      borderBottomWidth: 1,
      borderColor: 'black',
      padding: 10,
    },
    label: {
      fontSize: 11,
      fontWeight: 'bold',
      fontFamily: 'Helvetica-Bold',
      marginRight: 10,
    },
    text: {
      fontSize: 11,
      fontWeight: 'bold',
      fontFamily: 'Helvetica-Bold',
      flex: 1,
    },
    text2: {
      margin: "0px 0px 0px 10px",
      fontFamily: 'Helvetica',
      fontSize: 11,
      flex: 1, // Allow text to wrap
    },
    text_report:{
      margin: "0px 0px 0px 20px",
      fontFamily: 'Helvetica',
      fontSize: 11,
      flex: 1, // Allow text to wrap
    },
    boldText: {
      fontFamily: 'Helvetica-Bold',
      fontSize: 11,
      color: 'black',
    },
    row: {
      flexDirection: 'row',
      alignContent: 'left',
      textAlign: 'left',
      marginBottom: 5, // Add margin between rows
    },
    rowtable: {
      flexDirection: 'row',
      alignItems: 'center',
      margin: '0px 2px 0px 2px',
      borderLeft:'1px solid #000',
      borderBottom: '1px solid #000',
      borderRight: '1px solid #000',
      padding: '2px'
    },
    cell: {
      fontFamily: 'Helvetica',
      fontSize: 11,
      borderRight: '1px solid #000',
      alignItems: 'flex-start',
    },
    imageCell: {
      width: '10%', // Adjusted to fit better
      justifyContent: 'center',
      alignItems: 'center',
    },
    textCell: {
      width: '90%', // Adjusted to fit better
      paddingLeft: '5px',
    },
    image: {
      objectFit: 'cover',
      width: '90%',
    },
    reportColumn:{
      flexDirection: "column", borderLeft: "1px solid #000", borderBottom: "1px solid #000",fontSize: 11, fontFamily: 'Helvetica',padding: "10px 5px 10px 5px",
      width: "35%"
    },
    reporttableColumn:{
      flexDirection: "column",  borderLeft: "1px solid #000", borderBottom: "1px solid #000",fontSize: 11, fontFamily: 'Helvetica',padding: "10px 5px 10px 5px",
      width: "10%"
    },
    rightBorder: {
     borderRight:"1px solid #000"
    },
    report_sub_heading:{
      marginTop: "10px",
    },
  });

  // Helper function to handle token expiration
  const handleTokenExpired = (errorMessage = "Session expired. Please login again.") => {
    console.log('handleTokenExpired: Logging out user due to expired token');

    // Clear all authentication data from localStorage
    localStorage.removeItem('local_login');
    localStorage.removeItem('user_name');
    localStorage.removeItem('user_avatar');

    // Show error message to user
    setPdfCacheError(errorMessage);

    // Redirect to login page after a brief delay to show the error
    setTimeout(() => {
      window.location.href = "/";
    }, 1500);
  };

  // PDF Caching Functions
  const checkCachedPDF = async () => {
    try {
      setIsLoadingCachedPdf(true);
      setPdfCacheError("");

      console.log('checkCachedPDF: Checking for cached file... Report type:', r_type);

      // For viewing, request inline disposition (no custom filename needed)
      const response = await axios.get(`/pdf-api/reports/${id}/pdf/${r_type}?disposition=inline`, {
        headers: { Authorization: token_logged }
      });

      console.log('checkCachedPDF response:', response.data);

      if (response.data.exists) {
        console.log('checkCachedPDF: Cached file found, setting URL:', response.data.url);
        setCachedPdfUrl(response.data.url);
        return response.data.url; // Return the URL instead of just true
      } else {
        console.log('checkCachedPDF: No cached file exists');
        return false;
      }
    } catch (error) {
      console.log('checkCachedPDF: Error checking cache:', error);
      setPdfCacheError("Failed to check cached PDF");
    } finally {
      setIsLoadingCachedPdf(false);
    }
    return false;
  };

  // Pre-fetch and convert images to base64 for faster PDF generation
  const prefetchImagesAsBase64 = async () => {
    const imageCache = {};
    const imageUrls = [];

    // Collect all Firebase image URLs from sections
    sections.forEach(code_reference => {
      // Collect photo URLs
      if (code_reference.photos_added_show && code_reference.photos_added_show.length > 0) {
        code_reference.photos_added_show.forEach(photo => {
          const url = getFirebaseImageUrl(photo.name);
          if (!imageCache[url]) {
            imageUrls.push({ url, key: url });
            imageCache[url] = true;
          }
        });
      }

      // Collect figure URLs
      if (code_reference.figures_added_show && code_reference.figures_added_show.length > 0) {
        code_reference.figures_added_show.forEach(figure => {
          const url = image_url_f + report.dataset_description.split(" ").join("_").split("(").join("").split(")").join("") + "/" + figure.img + ".png";
          if (!imageCache[url]) {
            imageUrls.push({ url, key: url });
            imageCache[url] = true;
          }
        });
      }
    });

    const totalImages = imageUrls.length;
    console.log(`Pre-fetching ${totalImages} images...`);

    // Function to fetch single image with retry logic
    const fetchImageWithRetry = async (imageUrl, retries = 3) => {
      for (let attempt = 1; attempt <= retries; attempt++) {
        try {
          const response = await fetch(imageUrl, { mode: 'cors' });
          if (!response.ok) throw new Error(`HTTP ${response.status}`);

          const blob = await response.blob();

          // Convert to base64
          return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          });
        } catch (error) {
          console.error(`Attempt ${attempt}/${retries} failed for image:`, imageUrl, error);
          if (attempt === retries) {
            console.error(`Failed to fetch image after ${retries} attempts:`, imageUrl);
            return null; // Return null for failed images
          }
          // Wait before retry (exponential backoff)
          await new Promise(resolve => setTimeout(resolve, 1000 * attempt));
        }
      }
    };

    // Fetch images in batches to avoid overwhelming the browser
    const batchSize = 10;
    let completed = 0;

    for (let i = 0; i < imageUrls.length; i += batchSize) {
      const batch = imageUrls.slice(i, i + batchSize);

      const results = await Promise.all(
        batch.map(async ({ url, key }) => {
          const base64 = await fetchImageWithRetry(url);
          completed++;

          // Update progress
          const progressPercent = Math.round((completed / totalImages) * 50); // 0-50% for image fetching
          setPdfGenerationProgress(progressPercent);
          setPdfGenerationStatus(`Fetching images...`);

          return { key, base64 };
        })
      );

      // Store results in cache
      results.forEach(({ key, base64 }) => {
        if (base64) {
          imageCache[key] = base64;
        }
      });
    }

    console.log(`Successfully cached ${Object.keys(imageCache).length}/${totalImages} images`);
    return imageCache;
  };

  const generateAndCachePDF = async (sectionsData = null, imageCache = null) => {
    try {
      setIsLoadingCachedPdf(true);
      setPdfCacheError("");
      setPdfGenerationProgress(0);
      setPdfGenerationStatus("Preparing PDF generation...");

      // Use provided sections or fall back to state
      const activeSections = sectionsData || sections;

      if (!activeSections || activeSections.length === 0) {
        console.error('Cannot generate PDF: No sections data available');
        setPdfCacheError("Cannot generate PDF: Report data not loaded yet. Please wait and try again.");
        return false;
      }

      console.log('Starting PDF generation...');
      console.log(`Using ${activeSections.length} sections for PDF generation`);

      // PHASE 1: Pre-fetch all images (0-50%)
      setPdfGenerationStatus("Pre-fetching images...");
      const fetchedImageCache = imageCache || await prefetchImagesAsBase64();
      // Store in state for UI display (optional, not used by PDF)
      setCachedImages(fetchedImageCache);

      console.log(`Image pre-fetch complete. Cached ${Object.keys(fetchedImageCache).length} images.`);

      // Allow UI to update before starting heavy operation
      await new Promise(resolve => setTimeout(resolve, 100));

      // PHASE 2: Generate PDF (50-75%)
      const totalSections = activeSections.length || 1;
      setPdfGenerationProgress(50);
      setPdfGenerationStatus(`Rendering PDF document...`);

      // Simulate progressive section rendering
      const sectionProgressRange = 25; // 50-75% for PDF rendering
      const sectionProgressPerSection = sectionProgressRange / totalSections;
      const intervalMs = Math.max(200, 5000 / totalSections); // Spread over ~5 seconds

      let currentSectionSimulated = 0;
      const progressInterval = setInterval(() => {
        if (currentSectionSimulated < totalSections) {
          currentSectionSimulated++;
          const progress = Math.min(50 + (currentSectionSimulated * sectionProgressPerSection), 75);
          setPdfGenerationProgress(Math.round(progress));
          setPdfGenerationStatus(`Rendering PDF document...`);
        }
      }, intervalMs);


      const blob = await pdf(<MyDocument imageCache={fetchedImageCache} sectionsData={activeSections} />).toBlob();

      // Clear the interval once generation is complete
      clearInterval(progressInterval);

      console.log('PDF blob generated:', {
        size: blob.size,
        type: blob.type,
        isEmpty: blob.size === 0,
        sections: totalSections
      });

      if (blob.size === 0) {
        throw new Error('Generated PDF is empty (0 bytes). Check for missing images or PDF generation errors.');
      }

      // PHASE 3: Upload to S3 (75-100%)
      setPdfGenerationProgress(75);
      setPdfGenerationStatus("Preparing upload...");

      // Allow UI to update
      await new Promise(resolve => setTimeout(resolve, 50));
      
      console.log('Refreshing the access token before upload');
      let freshToken = token_logged;
      try {
        const refreshResponse = await axios.post('/user/refresh_token');
        freshToken = refreshResponse.data.access_token;
        settoken_logged(freshToken);
        console.log('Access token refreshed successfully');
      } catch (refreshError) {
        console.error('Failed to refresh token:', refreshError);
        // If token refresh fails with 401/403, the session has expired
        if (refreshError.response && (refreshError.response.status === 401 || refreshError.response.status === 403)) {
          handleTokenExpired("Your session has expired. Please login again.");
          return null;
        }
        // For other errors, continue with existing token (might still work)
        console.warn('Continuing with existing token');
      }

      // Upload to S3 cache
      const formData = new FormData();
      formData.append('pdf', blob, generateFileName(report));

      setPdfGenerationProgress(80);
      setPdfGenerationStatus("Uploading PDF to server...");

      const response = await axios.post(`/pdf-api/reports/${id}/pdf/${r_type}`, formData, {
        headers: {
          Authorization: freshToken  // Use freshly refreshed token
          // Note: Don't set Content-Type for FormData - browser sets it automatically with boundary
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 15) / progressEvent.total);
          setPdfGenerationProgress(80 + percentCompleted);
        }
      });

      console.log('Upload response:', response.data);

      if (response.data.success) {
        setPdfGenerationProgress(98);
        setPdfGenerationStatus("Finalizing...");

        console.log('PDF upload successful, getting cached URL...');
        // Get the cached PDF URL
        const cachedUrl = await checkCachedPDF();

        setPdfGenerationProgress(100);
        setPdfGenerationStatus("Complete!");

        return cachedUrl; // Return the URL instead of just true
      } else {
        console.error('Upload response indicates failure:', response.data);
        return false;
      }
    } catch (error) {
      console.error('Error generating and caching PDF:', error);
      console.error('Error response:', error.response?.data);
      console.error('Error status:', error.response?.status);

      // Check if it's an authentication error
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        handleTokenExpired("Your session has expired. Please login again.");
        return null;
      }

      setPdfCacheError("Failed to cache PDF: " + (error.response?.data?.error || error.message));
      setPdfGenerationStatus("");
    } finally {
      // Reset after a short delay to show completion
      setTimeout(() => {
        setIsLoadingCachedPdf(false);
        setPdfGenerationProgress(0);
        setPdfGenerationStatus("");
      }, 500);
    }
    return false;
  };

  const handleViewCachedPDF = async () => {
    console.log('handleViewCachedPDF: Starting...');
    
    try {
      // Use existing checkCachedPDF function instead of duplicating API call
      console.log('handleViewCachedPDF: Checking cache for report type:', r_type);
      const cachedUrl = await checkCachedPDF();
      
      if (cachedUrl) {
        console.log('handleViewCachedPDF: Valid cached file found, displaying PDF inline');
        setShowCachedPdf(true);
        return;
      }
      
      // If no valid cache exists, generate new PDF
      console.log('handleViewCachedPDF: No valid cache found, generating new PDF...');
      const generatedUrl = await generateAndCachePDF();
      if (generatedUrl) {
        console.log('handleViewCachedPDF: Generated new PDF, displaying inline:', generatedUrl);
        // Update the cached PDF URL state with the new URL
        setCachedPdfUrl(generatedUrl);
        setShowCachedPdf(true);
      } else {
        console.error('handleViewCachedPDF: Failed to generate PDF');
        setPdfCacheError("Failed to generate PDF. Please try again.");
      }
    } catch (error) {
      console.error('handleViewCachedPDF: Error:', error);
      setPdfCacheError("Failed to check or generate cached PDF");
    }
  };

  const handleDownloadCachedPDF = async () => {
    console.log('handleDownloadCachedPDF: Starting for report type:', r_type);

    try {
      // First ensure a cached PDF exists (either already cached or generate new one)
      if (!cachedPdfUrl) {
        const cachedUrl = await checkCachedPDF();
        if (!cachedUrl) {
          console.log('handleDownloadCachedPDF: No cache found, generating PDF...');
          const generatedUrl = await generateAndCachePDF();
          if (!generatedUrl) {
            console.error('handleDownloadCachedPDF: Failed to generate PDF');
            setPdfCacheError("No PDF available to download. Please generate one first.");
            return;
          }
        }
      }

      // Refresh token before making the download request
      let freshToken = token_logged;
      try {
        console.log('handleDownloadCachedPDF: Refreshing access token...');
        const refreshResponse = await axios.post('/user/refresh_token');
        freshToken = refreshResponse.data.access_token;
        settoken_logged(freshToken);
        console.log('handleDownloadCachedPDF: Access token refreshed successfully');
      } catch (refreshError) {
        console.error('handleDownloadCachedPDF: Failed to refresh token:', refreshError);
        // If token refresh fails with 401/403, the session has expired
        if (refreshError.response && (refreshError.response.status === 401 || refreshError.response.status === 403)) {
          handleTokenExpired("Your session has expired. Please login again.");
          return;
        }
        // For other errors, continue with existing token (might still work)
        console.warn('handleDownloadCachedPDF: Continuing with existing token');
      }

      // Validate report ID and type
      if (!id || !r_type) {
        console.error('handleDownloadCachedPDF: Invalid report ID or type', { id, r_type });
        setPdfCacheError("Invalid report information. Please refresh the page and try again.");
        return;
      }

      // Generate and validate filename
      const rawFilename = generateFileName(report);
      console.log('=== FILENAME DEBUG ===');
      console.log('report.report_name:', report.report_name);
      console.log('text2:', text2);
      console.log('rawFilename generated:', rawFilename);
      console.log('encodeURIComponent(rawFilename):', encodeURIComponent(rawFilename));
      console.log('=== END FILENAME DEBUG ===');

      if (!rawFilename || rawFilename === 'report.pdf') {
        console.warn('handleDownloadCachedPDF: Using default filename');
      }
      const filename = encodeURIComponent(rawFilename);
      console.log('handleDownloadCachedPDF: Requesting download URL with filename:', rawFilename);

      // Now request a download-specific signed URL with attachment disposition and correct filename
      const response = await axios.get(`/pdf-api/reports/${id}/pdf/${r_type}?disposition=attachment&filename=${filename}`, {
        headers: { Authorization: freshToken }
      });

      console.log('handleDownloadCachedPDF: Response received:', {
        exists: response.data.exists,
        hasUrl: !!response.data.url,
        status: response.status
      });

      if (response.data.exists && response.data.url) {
        console.log('handleDownloadCachedPDF: Download URL received, triggering download');
        console.log('S3 Signed URL:', response.data.url);
        console.log('Using filename for download:', rawFilename);
        const link = document.createElement('a');
        link.href = response.data.url;
        link.download = rawFilename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        console.error('handleDownloadCachedPDF: No download URL received', response.data);
        setPdfCacheError("Failed to get download URL. Please try again.");
      }
    } catch (error) {
      console.error('handleDownloadCachedPDF: Error:', error);

      // Provide more specific error messages
      if (error.response) {
        const status = error.response.status;
        console.error('handleDownloadCachedPDF: Server responded with status:', status);
        console.error('handleDownloadCachedPDF: Error data:', error.response.data);

        if (status === 400) {
          setPdfCacheError("Bad request - Invalid PDF download parameters. Please try regenerating the PDF.");
        } else if (status === 401 || status === 403) {
          // Session expired, logout user
          handleTokenExpired("Your session has expired. Please login again.");
          return;
        } else if (status === 404) {
          setPdfCacheError("PDF not found. Please regenerate the PDF and try again.");
        } else {
          setPdfCacheError(`Server error (${status}). Please try again.`);
        }
      } else if (error.request) {
        console.error('handleDownloadCachedPDF: No response received from server');
        setPdfCacheError("Network error. Please check your connection and try again.");
      } else {
        console.error('handleDownloadCachedPDF: Request setup error:', error.message);
        setPdfCacheError("Failed to download PDF. Please try again.");
      }
    }
  };

  const handleDeleteAndRegeneratePDF = async () => {
    console.log('handleDeleteAndRegeneratePDF: Starting for report type:', r_type);

    // Validate that sections data is loaded before proceeding
    if (!sections || sections.length === 0) {
      console.error('handleDeleteAndRegeneratePDF: Cannot regenerate - sections data not loaded');
      setPdfCacheError("Cannot regenerate PDF: Report data is not loaded. Please refresh the page and try again.");
      return;
    }

    console.log('handleDeleteAndRegeneratePDF: Validation passed, sections available:', sections.length);
    setIsLoadingCachedPdf(true);
    setPdfCacheError("");

    try {
      // First, delete the cached PDF from S3
      console.log('handleDeleteAndRegeneratePDF: Deleting cached PDF...');
      const deleteResponse = await axios.delete(`/pdf-api/reports/${id}/pdf/${r_type}`, {
        headers: { Authorization: token_logged }
      });

      console.log('handleDeleteAndRegeneratePDF: Delete response:', deleteResponse.data);

      // Clear cached URL and hide cached PDF view
      setCachedPdfUrl("");
      setShowCachedPdf(false);

      // Generate new PDF
      console.log('handleDeleteAndRegeneratePDF: Generating new PDF...');
      const generatedUrl = await generateAndCachePDF();

      if (generatedUrl) {
        console.log('handleDeleteAndRegeneratePDF: New PDF generated successfully:', generatedUrl);
        // Update the cached PDF URL state with the new URL
        setCachedPdfUrl(generatedUrl);
        setShowCachedPdf(true);
      } else {
        console.error('handleDeleteAndRegeneratePDF: Failed to generate new PDF');
        setPdfCacheError("Failed to regenerate PDF. Please try again.");
      }
    } catch (error) {
      console.error('handleDeleteAndRegeneratePDF: Error:', error);
      setPdfCacheError("Failed to delete and regenerate PDF");
    } finally {
      setIsLoadingCachedPdf(false);
    }
  };

  // Create Document Component
  // Accept imageCache and sections Data as parameters to avoid React state timing issues
  const MyDocument = ({ imageCache = {}, sectionsData = null }) => {
    // Use provided sections or fall back to state
    const activeSections = sectionsData || sections;

    return (
    <Document title={generateFileName(report)}>
      <Page size="A4" style={styles.page} renderAnnotationLayer={false}
           renderTextLayer={false}>
       <View style={{flexDirection: "column",margin: "0px 0px 5px 20px" }} >
        <View style={{flexDirection: "row", alignContent: "center", marginTop: "10px"}} >
          {(logo != "") && (
            <View style={{width: "100%", flexDirection: "row", alignContent: "center", justifyContent: "center"}} >
              <Image
                style={{height: "60px", alignSelf: "flex-end"}}
                src={logo}
              />
            </View>
          )}


        
        </View>
        <View style={{ margin: "15px 0px 5px 0px", flexDirection: "column", alignContent: "center", textAlign : "center"}} >
          <Text style={{fontFamily: 'Helvetica-Bold', fontSize: 18}} >{report.report_name}</Text>
          <View style={{margin: "10px 0px 0px 0px",flexDirection: "row", alignContent: "center",  justifyContent: "center"}} >
              <Text style={{fontFamily: 'Helvetica-Bold', fontSize: 18, color: textColor}} >{text2}</Text>
              <Text style={{fontFamily: 'Helvetica-Bold', fontSize: 18}} > - ADA Report</Text>
          </View>
         </View>
{/* 
        <View style={{ margin: "10px 0px 10px 0px", flexDirection: "column", alignContent: "center", textAlign : "center"}} >
            <Text style={{fontFamily: 'Helvetica', fontSize: 16}} >ADA, Architectural & Construction Consultants & Experts </Text>
            <Text style={{fontFamily: 'Helvetica-Bold', fontSize: 13}} >PARTIAL DISABLED ACCESS ADA</Text>
            <Text style={{fontFamily: 'Helvetica-Bold', fontSize: 13}} >COMPLIANCE SITE INSPECTION REPORT</Text>
            <Text style={{fontFamily: 'Helvetica-Bold', fontSize: 13, color: "#ef0000"}} >{text2}</Text>
            <Text style={{fontFamily: 'Helvetica', fontSize: 13}} >Protected by Attorney/Client Work Product Privilege</Text>
        </View>

        <View style={{ padding: "0px 20%", margin: "15px 0px 0px 0px", flexDirection: "column", alignContent: "center", textAlign : "center"}} >
            <Text style={{fontFamily: 'Helvetica', fontSize: 12}} >https://Arcor-Inc.com </Text>
            <Text style={{fontFamily: 'Helvetica', fontSize: 12}} >Toll Free Ph: (866)613-2519</Text>
        </View> */}

        <View style={{ margin: "15px  0px 5px 20px", flexDirection: "column", alignContent: "left", textAlign : "left"}} >
                <View style={{ margin: "2px 0px 2px 5px",flexDirection: "row", alignContent: "left", textAlign : "left"}} >  
                 <Text style={{fontFamily: 'Helvetica-Bold', fontSize: 13}} >ARCOR Inc Case: </Text>
                 <Text style={{fontFamily: 'Helvetica', fontSize: 13}} >{report.case_number}-{report.subcasenumber}</Text>
                </View>
        
                <View style={{ margin: "2px 0px 2px 5px",flexDirection: "row", alignContent: "left", textAlign : "left"}} >
                   <Text style={{fontFamily: 'Helvetica-Bold', fontSize: 13}} >Property Address: </Text>
                   <Text style={{fontFamily: 'Helvetica', fontSize: 13}} >{report.formatted_address}</Text>
                </View>
        
                <View style={{ margin: "2px 0px 2px 5px",flexDirection: "row", alignContent: "left", textAlign : "left"}} >
                    <Text style={{fontFamily: 'Helvetica-Bold', fontSize: 13}} >Inspection Date: </Text>
                    <Text style={{fontFamily: 'Helvetica', fontSize: 13}} >{report_date}</Text>
                </View>
      </View>

        {(image_cover != "") && (
          <View style={{flexDirection: "column",width: "100%", justifyContent: "center", alignItems: "center", margin_top: "20px", maxHeight: "300px", }} >
            <View style={{width: "90%", borderColor: "#224B8B", borderWidth: 3 }} >
              <Image
                style={{ objectFit: "cover", width: "100%", alignSelf: "center", margin_top: "15px",   }}            
                src={image_cover}
              />
            </View>
          </View>
        )}

      <View style={{ margin:  "5px 0px 5px 20px", flexDirection: "column", alignContent: "left", textAlign : "left"}} > 
          <View style={{ margin:"2px 0px 2px 5px",flexDirection: "row", alignContent: "left", textAlign : "left"}} >
               <Text style={{fontFamily: 'Helvetica-Bold', fontSize: 13}} >Prepared by: </Text>
               <Text style={{fontFamily: 'Helvetica', fontSize: 13}} >Steven E. Schraibman AIA, CPE CASp </Text>
         </View>
         <View style={{ margin: "2px 0px 2px 5px",flexDirection: "row", alignContent: "left", textAlign : "left"}} >
               <Text style={{fontFamily: 'Helvetica-Bold', fontSize: 13}} >Certified Access Specialist: </Text>
               <Text style={{fontFamily: 'Helvetica', fontSize: 13}} >CASp #338 </Text>
         </View>

          <View style={{ margin:"2px 0px 2px 5px", flexDirection: "row", alignContent: "left", textAlign : "left"}} >
               <Text style={{fontFamily: 'Helvetica-Bold', fontSize: 13}} >Licensed Architect: </Text>
               <Text style={{fontFamily: 'Helvetica', fontSize: 13}} >AIA #C28839</Text>      
         </View>
         <View style={{margin: "2px 0px 2px 5px", flexDirection: "row", alignContent: "left", textAlign : "left"}} >
               <Text style={{fontFamily: 'Helvetica-Bold', fontSize: 13} }>AIA Member ID: </Text>
               <Text style={{fontFamily: 'Helvetica', fontSize: 13}} >30123683</Text>      
         </View>
         <View style={{ margin:"2px 0px 2px 5px",flexDirection: "row", alignContent: "left", textAlign : "left"}} >
               <Text style={{fontFamily: 'Helvetica-Bold', fontSize: 13}} >Certified Professional Estimator: </Text>
               <Text style={{fontFamily: 'Helvetica', fontSize: 13}} >CPE#1.4-000302-1101 ASPE Member ID: 34607262</Text>      
         </View>
         <View style={{margin:"2px 0px 2px 5px", flexDirection: "row", alignContent: "left", textAlign : "left"}} >
               <Text style={{fontFamily: 'Helvetica-Bold', fontSize: 13}} >Certified Access Specialist: </Text>
               <Text style={{fontFamily: 'Helvetica', fontSize: 13}} >CASp #338</Text>
         </View>
         <View style={{ margin:"2px 0px 2px 5px",flexDirection: "row", alignContent: "left", textAlign : "left"}} >
               <Text style={{fontFamily: 'Helvetica-Bold', fontSize: 12}} >Contractors State License Board: </Text>
               <Text style={{fontFamily: 'Helvetica', fontSize: 12}} >#779611 Class Certification B</Text>      
        </View>
      </View>

      <View style={{ margin: "10px 0px 10px 0px", flexDirection: "column", alignContent: "center", textAlign : "center"}} >
          <Text style={{fontFamily: 'Times-Italic', fontSize: 13}} >Protected by Attorney/Client Work Product Privilege</Text>
      </View>

      <View style={{ padding: "0px 20%", margin: "15px 0px 0px 0px", flexDirection: "column", alignContent: "center", textAlign : "center"}} >
          <Text style={{fontFamily: 'Helvetica', fontSize: 12}} >Arcor-Inc.com </Text>
          <Text style={{fontFamily: 'Helvetica', fontSize: 12}} >(866)613-2519</Text>
      </View>
        
        
        <View break></View>

        <View style={{ margin: "30px 0px 30px 0px", flexDirection: "column", alignContent: "center", textAlign : "center"}} >
            <Text id= 'Tableofcontents'bookmark={{ title: "TABLE OF CONTENTS", fit: true }}style={{fontFamily: 'Helvetica-Bold', fontSize: 18}} >TABLE OF CONTENTS</Text>
        </View>

        <Link src='#ReportGuide'>
        <View style={{ margin: "5px 0px 5px 20px", flexDirection: "column", alignContent: "center", textAlign : "left"}} >
        <View style={{flexDirection: "row", alignContent: "left", textAlign : "left"}}>
        <Text style={{ margin: "0px 0px 0px 20px",textDecoration: 'none',fontFamily: 'Helvetica-Bold', fontSize: 14 ,color:'black'}}>{`\u2022`}</Text>
        <Text style={{ margin: "0px 0px 0px 5px",fontFamily: 'Helvetica-Bold', fontSize: 14 }}>  Report Guide</Text>
        </View>
        </View>
        </Link>

       <Link src={`#${indice[0] ? indice[0][1] : 'Section1'}`}> 
        <View style={{ margin: "5px 0px 5px 20px", flexDirection: "column", alignContent: "center", textAlign : "left"}} >
         <View style={{flexDirection: "row", alignContent: "left", textAlign : "left"}}>
         <Text style={{ margin: "0px 0px 0px 20px",textDecoration: 'none',fontFamily: 'Helvetica-Bold', fontSize: 14 ,color:'black'}}>{`\u2022`}</Text>
         <Text style={{ margin: "0px 0px 0px 5px",fontFamily: 'Helvetica-Bold', fontSize: 14 }}>  Sections</Text>
         </View>
         </View>
        </Link>

        {indice.map((indicePair, key) =>
       <View key={key} style={{ margin: "5px 0px 5px 20px", flexDirection: "column", alignContent: "center", textAlign : "left"}} >
         <Link src={`#${indicePair[1]}`}>
        <View style={{ flexDirection: "row", alignContent: "center", textAlign : "left"}}>
         <View style={{flexDirection: "row", alignContent: "left", textAlign : "left"}}>
            <Text style={{margin: "0px 0px 0px 30px", textDecoration: 'none',fontFamily: 'Helvetica-Bold', fontSize: 14 ,color:'black'}}>{`\u2022`}</Text>
            <Text style={{ margin: "0px 0px 0px 5px",fontFamily: 'Helvetica', fontSize: 14 }}>  Section {indicePair[0].split(':')[0]}:</Text>
            <Text style={{ margin: "0px 0px 0px 0px",fontFamily: 'Helvetica', fontSize: 14  }}>{indicePair[0].split(':')[1]}</Text>
            </View>
          </View>
          </Link>
       </View>
        )}

         {(text2 != "Compliant") && (
        <Link src='#ANTICIPATEDCOSTSUMMARY'>
        <View style={{ margin: "5px 0px 5px 20px", flexDirection: "column", alignContent: "center", textAlign : "left"}} >
        <View style={{flexDirection: "row", alignContent: "left", textAlign : "left"}}>
        <Text style={{margin: "0px 0px 0px 20px", textDecoration: 'none',fontFamily: 'Helvetica-Bold', fontSize: 14 ,color:'black'}}>{`\u2022`}</Text>
        <Text style={{margin: "0px 0px 0px 5px",fontFamily: 'Helvetica-Bold', fontSize: 14 }}>   Anticipated Cost Summary</Text>
        </View>
        </View>
        </Link>
         )}

        {/* 3rd page starts here as per the old report */}
        <View break></View>
        <View style={{padding: "10px 10px 10px 10px",margin: "15px 10px 15px 10px"}} >
        <View wrap={false} style={styles.report_header}>  
          <View style={{text_aling: "center", width: "100%", flexDirection: "column"}}>
            <Text id = 'ReportGuide' style={{ text_aling: "center", width: "100%", fontSize: 13}} >About Your Disability Access Inspection Report (CASP)</Text>
          </View>                                      
        </View>
        

        {/* <View style={{ margin: "20px 0px 5px 0px", flexDirection: "column", alignContent: "center", textAlign : "center"}} >
            <Text id = 'ReportGuide' style={{fontFamily: 'Helvetica-Bold', fontSize: 12}} >A. ABOUT YOUR DISABILITY ACCESS INSPECTION REPORT (CASp)</Text>
        </View> */}

        <View style={styles.report_text} >
            {/* <Text style={{fontFamily: 'Helvetica', fontSize: 11}} > */}
            <Text style={{fontFamily: 'Helvetica', fontSize: 11}} >
            This CASp Inspection Report and the Disability Access Inspection Certificate (DAIC), for the above listed
            property, has been provided by a Certified Access Specialist (CASp), in accordance with the Construction
            Related Accessibility Standards Compliance Act. The CASp Certificate will likely be issued as "CASp Determination Pending".
            </Text>
        </View>

        {/* <View style={{...styles.code_header_sub, color: "black",fontWeight: "bold",textAlign: "center", width: "100%"}}  >  
           <Text style={{ fontFamily: 'Helvetica'}} >CASp Certification Status</Text>
           </View>    */}

        <View wrap={false} style={styles.code_header_sub_bottom}>  
          <View style={{textAlign: "center",fontFamily: 'Helvetica-Bold', width: "100%", flexDirection: "column"}}>
            <Text style={{  width: "100%", fontSize: 15}} >CASp Certification Status</Text>
          </View>                                      
        </View>                
        
        {/* <View style={{...styles.report_text,flexDirection: "column"}} >
         <View style={{flexDirection: "row", alignContent: "left", textAlign : "left"}}>
           <Text style={{fontFamily: 'Helvetica-Bold',fontSize: 11}}>{`\u2022`}   "CASp Determination Pending”:</Text>
            <Text style={{ margin: "0px 0px 0px 2px",fontFamily: 'Helvetica', fontSize: 11  }}> Meansthat barriersto access have been 
             identified and are noted in the CASp Inspection Report.</Text>
           </View>
            <View style={{flexDirection: "row", alignContent: "left", textAlign : "left"}}>
              <Text style={{fontFamily: 'Helvetica-Bold', fontSize: 12 ,color:'black'}}>{`\u2022`}   "CASp-Inspected":</Text>
              <Text style={{ margin: "0px 0px 0px 2px",fontFamily: 'Helvetica', fontSize: 11  }} >Once all barriers are corrected to the fullest extent possible, your ADA CASp
               Report and Certification Status will be updated, as per a letter referencing to as such.</Text>
            </View>
        </View> */}
          <View style={{ ...styles.report_text }}>
          <View style={styles.row}>
          
           <Text style={styles.bullet}>{`\u2022`}</Text>
           <Text style={styles.text2}>
            <Text style={styles.boldText}>"CASp Determination Pending”:</Text>
              {' '}Means that barriers to access have been identified and are noted in the CASp Inspection Report.
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.bullet}>{`\u2022`}</Text>
            <Text style={styles.text2}>
            <Text style={styles.boldText}>"CASp-Inspected":</Text>
              {' '}Once all barriers are corrected to the fullest extent possible, your ADA CASp Report and Certification Status
              will be updated, as per a letter referencing to as such.
            </Text>
          </View>
        </View>
        <View wrap={false} style={styles.report_header}>  
          <View style={{text_aling: "center", width: "100%", flexDirection: "column"}}>
            <Text  style={{ text_aling: "center", width: "100%", fontSize: 13}} >What To Remember After Your Casp Inspection</Text>
          </View>                                      
        </View>
       <View style={styles.report_text} >
         <View style={styles.row}>
           <Text style={styles.bullet}>{`\u2022`}</Text>
           <Text style={styles.text2}>
            <Text style={styles.boldText}>CASp Certificate Storage & Placement:</Text>
              {' '}There is only one issued original of your serial numbered
              and watermarked CASp certificate. It is suggested that you store it safely with your records. Make a
              copy of your original issued CASp certificate and display it at a visible entry point to the inspected
              property.
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.bullet}>{`\u2022`}</Text>
            <Text style={styles.text2}>
            <Text style={styles.boldText}>CASp Report Confidentiality:</Text>
              {' '}Your CASp report should only be shared under the direction of legal
              counsel, or unless otherwise required by law. You may, however, share this report with the construction
              professionals you hire to achieve compliance.
            </Text>
          </View>
          <View style={styles.row}>
           <Text style={styles.bullet}>{`\u2022`}</Text>
           <Text style={styles.text2}>
            <Text style={styles.boldText}>CASp Inspected Business Listing:</Text>
              {' '}Completing the DSA Form 608 and reporting the information
              required to the Division of State Architects will include on the list of CASp inspected businesses. This
              action is voluntary & advantageous to you.
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.bullet}>{`\u2022`}</Text>
            <Text style={styles.text2}>
            <Text style={styles.boldText}>Schedule of Improvements Adherence: </Text>
              {' '}: It is essential that you work towards bringing the barriers
              identified in this report, into compliance. This demonstrates your intent to follow the law and be in
              compliance.
            </Text>
          </View>
          <View style={styles.row}>
           <Text style={styles.bullet}>{`\u2022`}</Text>
           <Text style={styles.text2}>
            <Text style={styles.boldText}>Follow-Up Inspection:</Text>
              {' '}A follow up inspection of your property will be required, once you have fixed
               the barrierslisted in your ADA Report, in orderto ensure that they now meet ADA Standards. Your Casp
               Report will be updated accordingly & status changed from "CASp Determination Pending", to "CASp
               Inspected".
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.bullet}>{`\u2022`}</Text>
            <Text style={styles.text2}>
            <Text style={styles.boldText}>Maintenance of Accessible Features:</Text>
              {' '} Establish a plan to stay in compliance. Ask your CASp which
              construction-related accessibility standards require periodic maintenance and establish a policy to
              check maintenance items regularly. Review operational policies that may intermittently affect
              compliance and establish procedures to ensure access is provided. Inform your employees about
              maintenance and operational policies that affect access to your facility.
            </Text>
          </View>
        </View>

        <View wrap={false} style={styles.report_header}>  
          <View style={{text_aling: "center", width: "100%", flexDirection: "column"}}>
            <Text  style={{ text_aling: "center", width: "100%", fontSize: 13}} >Understanding Your Casp Legal Benefits</Text>
          </View>                                      
        </View>
        <View wrap={false} style={styles.code_header_sub_bottom}>  
          <View style={{textAlign: "center",fontFamily: 'Helvetica-Bold', width: "100%", flexDirection: "column"}}>
            <Text style={{  width: "100%", fontSize: 15}} >Expiration of CASp Legal Benefits</Text>
          </View>                                      
        </View>
        <View style={styles.report_text} >
            {/* <Text style={{fontFamily: 'Helvetica', fontSize: 11}} > */}
            <Text style={{fontFamily: 'Helvetica', fontSize: 11}} >
            Legal benefits are granted regardless of whether your certification is designated as "CASp Determination
            Pending" or "CASp-Compliant". The "special legal rights and responsibilities", granted in accordance with 
            SB 262 and SB 1608, have been invoked, once your CASp Inspection has been done and CASp Report and
            Certificate, Issued.
            </Text>
        </View>
      </View>

        {/* 4th page starts here as per the old report */}
        <View style={{padding: "10px 10px 10px 10px",margin: "15px 10px 15px 10px"}} >
        <View wrap={false} style={[styles.code_header_sub_border,styles.report_sub_heading]}>  
          <View style={{textAlign: "center",fontFamily: 'Helvetica-Bold', width: "100%", flexDirection: "column"}}>
            <Text style={{  width: "100%", fontSize: 15}} >Qualified Defendant Status</Text>
          </View>                                      
        </View>
        <View style={styles.report_text} >
              <View style={styles.row}>
                 <Text style={{fontFamily: 'Helvetica',fontSize:11}}> If an Accessibility-Related Lawsuit is filed against your property or business and you have a CASp
                  Certificate you should understand and follow these steps.</Text></View>
                  <View style={styles.row}>
                    <Text style={styles.text_report}>

                  <Text style={styles.boldText}>a.</Text>
                    {' '}Apply for a 90 day stay of the lawsuit.
                  </Text>
                </View>
                <View style={styles.row}>
                  <Text style={styles.text_report}>
                  <Text style={styles.boldText}>b.</Text>
                    {' '}Request a mandatory early evaluation conference (ECC) within 35 days.
                  </Text>
                  </View>
                  <View style={styles.row}>
                  <Text style={styles.text_report}>
                  <Text style={styles.boldText}>c.</Text>
                    {' '}As the defendant, you will be required to produce this CASp Report, for the plaintiff review 15 days
                   prior to the ECC.
                  </Text>
                  </View>
                  <View style={styles.row}>
                  <Text style={styles.text_report}>
                  <Text style={styles.boldText}>d.</Text>
                    {' '}The plaintiff must provide basis for claimed violations and costs, 15 days prior to the ECC.
                  </Text>
                  </View>
                  <View style={styles.row}>
                  <Text style={styles.text_report}>
                  <Text style={styles.boldText}>e.</Text>
                    {' '}As a "qualified" or "CASp Certified" Business, you must display your issued "Disability Access
                    Certificate" (CASp Certificate), which is numbered and watermarked.
                  </Text>
                  </View>
                  <View style={styles.row}>
                   <Text style={{fontFamily: 'Helvetica',fontSize:11}} >Your CASp Certificate, can help reduce potential legal costs which usually occur as a result of the extensive
            time spent, when the plaintiff seeks a "settlement" award. It is the "special legal rights" that CASp Certified
            businesses receive, that reduces the likelihood of the business being targeted with frivolous lawsuits. The law
            aims to ensure that the rights of those with disabilities will be respected and catered for.</Text>
                   </View>
                  </View>
            {/* <Text style={{fontFamily: 'Helvetica', fontSize: 11}} > */}
            {/* <Text style={{fontFamily: 'Helvetica', fontSize: 11}} >
            If an Accessibility-Related Lawsuit is filed against your property or business and you have a CASp
            Certificate you should understand and follow these steps.{'\n'}
            <View style={{ flexDirection: 'row' }}>
              <Text style={{ margin: '10px 0px 15px 10px' }}><Text style={styles.boldText}>      a. </Text>Apply for a 90 day stay of the lawsuit.
              </Text>
              {'\n'}
              <Text style={{ margin: '10px 0px 15px 10px' }}><Text style={styles.boldText}>      b. </Text>Request a mandatory early evaluation conference (ECC) within 35 days.
              </Text>
              {'\n'}
              <Text style={{ margin: '10px 0px 15px 10px' }}><Text style={styles.boldText}>      c. </Text>As the defendant, you will be required to produce this CASp Report, for the plaintiff review 15 days
              prior to the ECC.
              </Text>
              {'\n'}
              <Text style={{ margin: '10px 0px 15px 10px' }}><Text style={styles.boldText}>      d. </Text>The plaintiff must provide basis for claimed violations and costs, 15 days prior to the ECC.
              </Text>
              {'\n'}
              <Text style={{ margin: '10px 0px 15px 10px' }}><Text style={styles.boldText}>      e. </Text>As a "qualified" or "CASp Certified" Business, you must display your issued "Disability Access
              Certificate" (CASp Certificate), which is numbered and watermarked.
              </Text>
            </View>
            Your CASp Certificate, can help reduce potential legal costs which usually occur as a result of the extensive
            time spent, when the plaintiff seeks a "settlement" award. It is the "special legal rights" that CASp Certified
            businesses receive, that reduces the likelihood of the business being targeted with frivolous lawsuits. The law
            aims to ensure that the rights of those with disabilities will be respected and catered for.
            
            </Text>
        </View> */}
        <View wrap={false} style={styles.report_header}>  
          <View style={{text_aling: "center", width: "100%", flexDirection: "column"}}>
            <Text wrap={false}  style={{ text_aling: "center", width: "100%", fontSize: 13}} >How To Understand & Navigate Your ADA Site Inspection Report</Text>
          </View>                                      
        </View>
        <View style={styles.report_text} >
            {/* <Text style={{fontFamily: 'Helvetica', fontSize: 11}} > */}
            <Text style={{fontFamily: 'Helvetica',fontSize:11}}><Text style={styles.boldText}>Adobe PDF Reader:{'\n'} </Text>In order to read your ADA Inspection Report, you will 
            require a PDF Reader. This is free and can be acquired using the following{' '} 
            <Link><Text>download link</Text></Link>
              </Text>
        </View>
        <View wrap={false} style={styles.code_header_sub_bottom}>  
          <View style={{textAlign: "center",fontFamily: 'Helvetica-Bold', width: "100%", flexDirection: "column"}}>
            <Text style={{ width: "100%", fontSize: 15}} >Report Types</Text>
          </View>                                      
        </View>
        <View style={styles.report_text} >
        <View style={styles.row}>
          <Text><Text style={styles.text2}><Text style={styles.boldText}>{`\u2022`}   </Text>Common Areas Only </Text>
              {'\n'}
              <Text style={styles.text2}><Text style={styles.boldText}>{`\u2022`}   </Text>Interior Only
              </Text>
              {'\n'}
              <Text style={styles.text2}><Text style={styles.boldText}>{`\u2022`}   </Text>Both Common & Interior Areas
              </Text></Text>
              
          
           {/* <Text style={styles.bullet}>{`\u2022`}</Text>
           <Text style={styles.text2}>
           Common Areas Only
            </Text>
         </View>
          <View style={styles.row}>
           <Text style={styles.bullet}>{`\u2022`}</Text>
           <Text style={styles.text2}>
           Interior Only
            </Text>
          </View>
          <View style={styles.row}>
           <Text style={styles.bullet}>{`\u2022`}</Text>
           <Text style={styles.text2}>
           Both Common & Interior Areas
            </Text> */}
          </View>
          </View>
          <View wrap={false} style={styles.code_header_sub_bottom}>  
        <View style={{textAlign: "center",fontFamily: 'Helvetica-Bold', width: "100%", flexDirection: "column"}}>
            <Text style={{ width: "100%", fontSize: 15}} >Report Versions</Text>
          </View>                                      
        </View>
          <View style={{ ...styles.report_text }}>
          <View style={styles.row}>
          
           <Text style={styles.bullet}>{`\u2022`}</Text>
           <Text style={styles.text2}>
            <Text style={styles.boldText}>ADA Compliant Report:</Text>
              {' '} For your convenience, this Report is filtered to show all the items inspected, that were found to be ADA Compliant & therefore correct.
            </Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.boldText}>{`\u2022`}</Text>
            <Text style={styles.text2}>
            <Text style={styles.boldText}>ADA Non-Compliant Report:</Text>
              {' '}For your convenience, this Report is filtered to show all the items inspected, that were found to be ADA Non-Compliant & therefore require correction & remediation.
            </Text>
          </View>
        </View>
        <View wrap={false} style={styles.code_header_sub_bottom}>  
          <View style={{textAlign: "center",fontFamily: 'Helvetica-Bold', width: "100%", flexDirection: "column"}}>
            <Text style={{ width: "100%", fontSize: 15}} >Property Variations</Text>
          </View>                                      
        </View>
        <View style={styles.report_text} >
            <View style={styles.row}>
             <Text style={{fontFamily: 'Helvetica',fontSize:11}}>Report items will vary depending on the type of property inspected. It is stated that the disabled shall have
                  equal opportunity and access to garnish themselves to goods and services.</Text></View>
            <View style={styles.row}>
             <Text style={styles.text2}><Text style={styles.boldText}>EX:</Text>
             {' '}Food Establishments, may vary situationally whether seating is provided or according to Public
               Health & Safety laws whether restrooms are required. Multifamily Housing may not include rental offices
               in some cases but will be required to provide an accessible alternative to inform the disabled of how to
               best view and access the property.
              </Text>
          </View>
        
            {/* <Text style={{fontFamily: 'Helvetica', fontSize: 11}} >
            Report items will vary depending on the type of property inspected. It is stated that the disabled shall have
            equal opportunity and access to garnish themselves to goods and services.{'\n'}
            <View style={styles.row}>
             <Text style={styles.text2}><Text style={styles.boldText}>         EX: </Text>
             Food Establishments, may vary situationally whether seating is provided or according to
             Public Health & Safety laws whether restrooms are required. Multifamily Housing may not include
             rental offices in some cases but will be required to provide an accessible alternative to inform the
             disabled of how to best view and access the property.
              </Text>
             </View>
            </Text> */}
         </View>


        </View>

      {/* 5th page starts here as per the old report */}
      <View style={{padding: "10px 10px 10px 10px",margin: "10px 10px 10px 10px"}} >
       <View wrap={false} style={styles.code_header_sub_border}>  
          <View style={{textAlign: "center",fontFamily: 'Helvetica-Bold', width: "100%", flexDirection: "column"}}>
            <Text style={{  width: "100%", fontSize: 15}} >Navigating Your Report</Text>
          </View>                                      
        </View>
        
       <View style={styles.flexDirectionRow}>
          <View style={[styles.reportColumn]} >
           <View style={styles.row}>
             <Text style={styles.boldtext}>1.</Text>
             <Text style={styles.text2}>Click on the desired
              <Link>“Section Title”</Link> on the Table of Contents
              </Text>
          </View>
           <View style={styles.row}>
            <Text style={styles.boldText}>2.</Text>
            <Text style={styles.text2}>To revert back, click <Link>“Table of Contents”</Link> at the bottom left corner of any page.</Text>
          </View>
         
          </View>
          <View style={styles.report_text } >
            {/* <View style={{ fontFamily: 'Helvetica', fontSize: 11, alignItems: "center" }}> */}
            <View style={{ fontFamily: 'Helvetica', fontSize: 11, alignItems: "flex-start" }}>
                 <Image 
                    style={{ objectFit: "cover", width: "100%", }}                       
                    src={TOC_IMAGE}
                  />   
              </View>
              </View>
              </View>
       <View wrap={false} style={styles.code_header_sub_bottom}>  
          <View style={{textAlign: "center",fontFamily: 'Helvetica-Bold', width: "100%", flexDirection: "column"}}>
            <Text style={{ width: "100%", fontSize: 15}} >Breaking Down Your Report
          </Text>
          </View>                                       
        </View>
        <View style={styles.flexDirectionRow}>
          <View style={[styles.reportColumn]} >
           <View style={styles.row}><Text style={{fontFamily:"Helvetica",fontSize:11}}>
             <Text><Text style={styles.boldText}>1.   </Text>Code Reference </Text>
              {'\n'}
              <Text><Text style={styles.boldText}>2.   </Text>Description
              </Text>
              {'\n'}
              <Text ><Text style={styles.boldText}>3.   </Text>Priority Status
              </Text>
              {'\n'}
              <Text ><Text style={styles.boldText}>4.   </Text>Comments
              </Text>
              {'\n'}
              <Text><Text style={styles.boldText}>5.   </Text>Recommendation
              </Text>
              {'\n'}
              <Text ><Text style={styles.boldText}>6.   </Text>Violations Photo
              </Text>
              {'\n'}
              <Text ><Text style={styles.boldText}>7.   </Text>Anticipated Cost
              </Text>
              {'\n'}
              <Text><Text style={styles.boldText}>8.   </Text>Reference Diagrams

              </Text>
              {'\n'} </Text>
            </View>
             
           </View>
            <View style={[styles.report_text, styles.rightBorder] } >
            <View style={{ fontFamily: 'Helvetica', fontSize: 11, alignItems: "flex-start" }}>
                <Image 
                    style={{ objectFit: "cover", width: "100%", }}                       
                    src={Section_IMAGE}
                  />  
              </View>
              </View>
                  
        </View> 
                  
        {/* </View> 

        <View style={{padding: "10px 10px 10px 10px",margin: "10px 10px 10px 10px"}} > */}
       <View wrap={false} style={styles.code_header_sub_bottom}>  
          <View style={{textAlign: "center",fontFamily: 'Helvetica-Bold', width: "100%", flexDirection: "column"}}>
            <Text style={{ width: "100%", fontSize: 15}} >Prioritizing Your Report</Text>
          </View>                                      
        </View>
        <View style={styles.flexDirectionRow}>
          <View style={[styles.reporttableColumn]} >
          <View style={{ fontFamily: 'Helvetica', fontSize: 10, alignItems: "center",justifyContent:"center" }}>
                <Image 
                    style={{ objectFit: "cover", width: "80%"}}                       
                    src={STATUS_2_IMAGE}
                  />  
              </View>
             
           </View>
            <View style={[styles.report_text, styles.rightBorder] } >
            <View style={styles.row}>
            <Text style={{fontFamily:"Helvetica",fontSize:10}}>
             Easily accomplished without undue expense, effort, and or, interruption of goods and services.
             </Text>
            </View>
            <View style={styles.row}>
            <Text style={{fontFamily:"Times-Italic",fontSize:10}} > <Text style={{fontWeight:'bold'}}>EX: </Text>
             Replacing incorrect "Accessible Parking" signage.
              </Text>
            </View>
            
              </View>
                  
        </View> 
        <View style={styles.flexDirectionRow}>
          <View style={[styles.reporttableColumn]} >
          <View style={{ fontFamily: 'Helvetica', fontSize: 10, alignItems: "center",justifyContent:"center" }}>
                <Image 
                    style={{ objectFit: "cover", width: "80%"}}                       
                    src={STATUS_3_IMAGE}
                  />  
              </View>
             
           </View>
            <View style={[styles.report_text, styles.rightBorder] } >
            <View style={styles.row}>
            <Text style={{fontFamily:"Helvetica",fontSize:10}}>
            Requires additional planning, co-ordination, and or, expenditure, to accomplish. Work may also  require a building permit for minor renovations and repair.
             </Text>
            </View>
            <View style={styles.row}><Text style={{fontFamily:"Times-Italic",fontSize:10}}>
             <Text style={{fontWeight:'bold'}}>EX: </Text>
             Resurfacing a parking lot structure that exceeds required slope threshold.
              </Text>
            </View>
            
              </View>
                  
        </View> 
        <View style={styles.flexDirectionRow}>
          <View style={[styles.reporttableColumn]} >
          <View style={{ fontFamily: 'Helvetica', fontSize: 10, alignItems: "center",justifyContent:"center"}}>
                <Image 
                    style={{ objectFit: "cover", width: "80%"}}                       
                    src={STATUS_4_IMAGE}
                  />  
              </View>
             
           </View>
            <View style={[styles.report_text, styles.rightBorder] } >
            <View style={styles.row}>
            <Text style={{fontFamily:"Helvetica",fontSize:10}}>
            Barrier removal cannot be readily achieved, without the imposition of undue hardship. Likely  involves significant allocation of resources and expenditure.
             </Text>
            </View>
            <View style={styles.row}><Text style={{fontFamily:"Times-Italic",fontSize:10}}>
             <Text style={{fontWeight:'bold'}}>EX: </Text>
             A parking lot located on a large and excessively sloped hill that is out of your control. 
              </Text>
            </View>
            
              </View>
                  
        </View>
        <View style={styles.flexDirectionRow}>
          <View style={[styles.reporttableColumn]} >
          <View style={{ fontFamily: 'Helvetica', fontSize: 10, alignItems: "center",justifyContent:"center" }}>
                <Image 
                    style={{ objectFit: "cover", width: "80%"}}                       
                    src={STATUS_6_IMAGE}
                  />  
              </View>
             
           </View>
            <View style={[styles.report_text, styles.rightBorder] } >
            <View style={styles.row}>
            <Text style={{fontFamily:"Helvetica",fontSize:10}}>
            Item is correct, and or, has been completed or remediated.  
             </Text>
            </View>
            <View style={styles.row}><Text style={{fontFamily:"Times-Italic",fontSize:10}}>
             <Text style={{fontWeight:'bold'}}>EX: </Text>
              A parking tot surface that meets required slope threshold. 
              </Text>
            </View>
            
              </View>
                  
        </View>
        <View style={styles.flexDirectionRow}>
          <View style={[styles.reporttableColumn]} >
          <View style={{ fontFamily: 'Helvetica', fontSize: 10, alignItems: "center",justifyContent:"center" }}>
                <Image 
                    style={{ objectFit: "cover", width: "80%"}}                       
                    src={STATUS_1_IMAGE}
                  />  
              </View>
             
           </View>
            <View style={[styles.report_text, styles.rightBorder] } >
            <View style={styles.row}>
            <Text style={{fontFamily:"Helvetica",fontSize:10}}>
            Barrier is non-applicable in this instance.
             </Text>
            </View>
            <View style={styles.row}><Text style={{fontFamily:"Times-Italic",fontSize:11}}>
             <Text style={{fontWeight:'bold'}}>EX: </Text>
             A normal noted car stall that does not require "Van Accessible" parking signage.
              </Text>
            </View>
            
              </View>
                  
        </View>
        {/* <View style={{flexDirection: 'column'}}>
            <View style={styles.rowtable}>
              <View style={[styles.cell, styles.imageCell]}>
                <Image style={styles.image} src={STATUS_2_IMAGE} />
              </View>
              <Text style={[styles.cell, styles.textCell]}>Easily accomplished without undue expense, effort, and or, interruption of goods and services.</Text>
            </View>
          
            <View style={styles.rowtable}>
              <View style={[styles.cell, styles.imageCell]}>
                <Image style={styles.image} src={STATUS_3_IMAGE} />
              </View>
              <Text style={[styles.cell, styles.textCell]}>Requires additional planning, co-ordination, and or, expenditure, in order to accomplish. Work may also require a building permit for minor renovations and repair.</Text>
            </View>
          
            <View style={styles.rowtable}>
              <View style={[styles.cell, styles.imageCell]}>
                <Image style={styles.image} src={STATUS_4_IMAGE} />
              </View>
              <Text style={[styles.cell, styles.textCell]}>Barrier removal cannot be readily achieved, without the imposition of undue hardship. Likely involves significant allocation of resources and expenditure.</Text>
            </View>
          
            <View style={styles.rowtable}>
              <View style={[styles.cell, styles.imageCell]}>
                <Image style={styles.image} src={STATUS_6_IMAGE} />
              </View>
              <Text style={[styles.cell, styles.textCell]}>Item is correct, and or, has been completed or remediated.</Text>
            </View>
          
            <View style={styles.rowtable}>
              <View style={[styles.cell, styles.imageCell]}>
                <Image style={styles.image} src={STATUS_1_IMAGE} />
              </View>
              <Text style={[styles.cell, styles.textCell]}>Barrier is non-applicable in this instance.</Text>
            </View>
          </View> */}

        </View>

          {activeSections.map((code_reference,key_section1) =>

                  <View style={{marginTop: "15px"}} >
                    {(code_reference.section_principal_t == 1) && (
                      <View wrap={false} style={styles.code_header}  >  
                        <View style={{text_align: "center", width: "100%", flexDirection: "column"}}>
                          <Text bookmark={{ title: "Section" + code_reference.section_principal, fit: true }} style={{ text_align: "center", width: "100%", fontSize: 13, fontWeight: "bold", fontFamily: 'Helvetica-Bold'}} >Section {code_reference.section_principal} </Text>
                          {(code_reference.section_principal_sub_1 == 1) && (
                            <Text style={{text_align: "center", width: "100%",fontSize: 13, fontWeight: "bold", fontFamily: 'Helvetica-Bold'}} >{code_reference.section_principal_sub} </Text>
                          )}
                        </View>                                      
                      </View>
                    )}
                    <View wrap={false}>
                    <View style={styles.code_header_sub}  >  
                        <View style={{ width: "50%", flexDirection: "row", marginLeft: "2px", flex: 1 }}>
                          <Text style={{ fontSize: 11, fontWeight: "bold", fontFamily: 'Helvetica-Bold' }}>
                           <span>Section: </span>
                           <span style={{ textAlign: "justify" }}>{code_reference.section_name_show}</span>
                          </Text>
                        </View>
                        <View style={{textAlign: "right", width: "50%", flexDirection: "row",marginRight: "10px", justifyContent: "flex-end", flex: 1}} >
                        <Text style={{fontSize: 11, fontWeight: "bold", fontFamily: 'Helvetica-Bold'}} >Code Reference: </Text>
                        <Text style={{fontSize: 11, fontWeight: "bold", fontFamily: 'Helvetica-Bold'}}> {String( code_reference.reference)} </Text>
                        </View>                
                    </View>

                    <View style={styles.flexDirectionRow}>
                          <View style={[styles.commonColumn]} >
                            <Text>Code Description</Text>
                            <View style={[styles.wrapWord,{marginTop:5}]}>
                              {code_reference?.description?.split(" ")?.map((word)=><Text>{`${word} `}</Text>)}
                            </View>
                          </View>
                          <View style={{ flexDirection: "column", borderTop: "1px solid #000", borderLeft: "1px solid #000", borderBottom: "1px solid #000", width: "10%",fontSize: 11,fontFamily: 'Helvetica'}} >
                            <Text style={{width: "100%",fontSize: 11, padding: "10px 5px 10px 5px", fontFamily: 'Helvetica'}}>Status</Text>
                            <View style={{width: "100%",fontSize: 11, padding: "0px 5px 10px 5px", alignContent: "center", alignItems: "center" }}>
                              <Image
                                style={{width: "90%"}}
                                src={
                                  code_reference.status === 1 ? STATUS_1_IMAGE :
                                  code_reference.status === 2 ? STATUS_2_IMAGE :
                                  code_reference.status === 3 ? STATUS_3_IMAGE :
                                  code_reference.status === 4 ? STATUS_4_IMAGE :
                                  code_reference.status === 6 ? STATUS_6_IMAGE :
                                  STATUS_1_IMAGE
                                }
                              />
                            </View>
                          </View>
                          <View style={[styles.commonColumn]} >
                            <Text >Comments</Text>
                            <View>
                                {(code_reference.comments_added.length > 0) && ( 
                                  <View style={{width: "100%",fontSize: 11, flexDirection: "column" }}>
                                    {code_reference.comments_added.map((comment,comment_key) =>
                                      <View style={{flexDirection: "row",marginTop:5}} key={comment_key}>
                                         <Text style={{marginRight:5}}>•</Text>
                                         <View style={styles.wrapWord}>
                    {comment?.comment_text?.split(" ")?.map((word)=><Text>{`${word} `}</Text>)}
                    </View>
                                      </View>
                                    )}
                                  </View>
                                )}
                                {(code_reference.comments_added.length == 0) && ( 
                                  <Text style={{width: "100%",fontSize: 11,   flexDirection: "row" }}>                              
                                      <Text>
                                        N/A
                                      </Text>
                                  </Text>
                                )}
                            </View>
                          </View>
                          <View style={[styles.commonColumn, styles.rightBorder]} >
                            <Text >Recommendations</Text>
                            <View>
                                {(code_reference.recommendations_added.length > 0) && ( 
                                  <View style={{width: "100%",fontSize: 11,  flexDirection: "column"}}>
                                    {code_reference.recommendations_added.map((recommendation,recommendation_key) =>
                                     <View style={{flexDirection: "row",marginTop:5}} key={recommendation_key}>
                                     <Text style={{marginRight:5}}>•</Text>
                                     <View style={styles.wrapWord}>
                                    {recommendation.recommendation_text?.split(" ")?.map((word)=><Text>{`${word} `}</Text>)}
                                    </View>
                                  </View>
                                    )}
                                  </View>
                                )}
                                {(code_reference.recommendations_added.length == 0) && ( 
                                  <Text style={{width: "100%",fontSize: 11,  flexDirection: "row" }}>                              
                                      <Text>
                                        N/A
                                      </Text>
                                  </Text>
                                )}
                            </View>
                          </View>
                          
                          
                    </View>

                    <View style={{flexDirection: "row"}}>
                          
                          
                          
                          
                          
                    </View>
                    </View>
                    {(code_reference.photos_added_show.length > 0) && ( 
                      
                      <View > 
                        
                        <View style={{flexDirection:'row', flexWrap: "wrap", marginTop: 10}} >
                          {code_reference.photos_added_show.map((photo,photo_key) => {
                            const photoUrl = getFirebaseImageUrl(photo.name);
                            const imageSrc = imageCache[photoUrl] || photoUrl;

                            return (
                            <View style={{width: "50%", paddingHorizontal: "10px", alignContent: "center", alignItems: "center",maxHeight: "250px"}}>
                              <Link to={photoUrl} >
                              <Image
                                style={{width: "100%", borderColor: "#224B8B", objectFit: "cover",
                                borderWidth: 3, padding: "3", margin: 5 }}
                                src={imageSrc}
                              />
                              </Link>
                              <View style={{ position: 'absolute', bottom: 10, width: '100%', alignItems: 'center' }}>
                                <Text style={{ backgroundColor: 'white', fontSize: 15, fontWeight: 'bold', color: 'black', padding: '0px 5px', textAlign: 'center' }}>
                                  {photo.photo_id}
                                </Text>
                              </View>
                              {/* <View style={{ display: "flex", alignContent: "flex-end", alignItems: "flex-end",  }} >
                                <Text style={{ alignSelf: "flex-end", backgroundColor: "white", marginTop: "-30px", marginRight: "-47%", fontSize: "15px", fontWeight: "bold", color: "black",  textAlign: "right", padding: "0px 5px", }} >
                                  {photo.photo_id}
                                </Text>
                              </View> */}
                            </View>
                            );
                          })}
                        </View>
                    </View>
                    
                    )}

                    {(code_reference.figures_added_show.length > 0) && ( 
                      <View wrap={false}>                         

                        <View style={{flexDirection:'row', flexWrap: "wrap", marginTop: 10}} >
                          {code_reference.figures_added_show.map((figure,photo_key) => {
                            const figureUrl = image_url_f + report.dataset_description.split(" ").join("_").split("(").join("").split(")").join("") +  "/" +  figure.img + ".png";
                            const imageSrc = imageCache[figureUrl] || figureUrl;

                            return (
                            <View style={{width: "100%", paddingHorizontal: "10px", justifyContent: "center", alignItems: "center" }}>


                                <Image style={{width: "50%", height: "auto"}} src={imageSrc} />

                            </View>
                            );
                          })}
                        </View>
                    </View>
                    )}                    
                    {(code_reference.signs_added.length > 0) && ( 
                      <View wrap={false}> 
                        <View style={{ backgroundColor: "#f3f3f3ff", flexDirection: "column", paddingBottom: 5, paddingTop: 5, marginTop: 20, marginBottom: 10, justifyContent: "center", alignItems: "center"}} >
                          <Text style={{ fontSize: 11, textAlign: "center",alignSelf: "center", fontFamily: 'Helvetica'}}>Anticipated Cost Of Repair</Text>
                        </View>
                        {(report?.signs || []).map((sign,sign_key) =>
                            <View style={{flexDirection: "column", width: "100%" }} > 
                              {(code_reference.signs_added[sign_key] > 0) && (
                                <View style={{flexDirection: "row", marginBottom: "15px" }} > 
                                    <View style={{width: "10%"}}>                                
                                      <Image
                                        style={{width: "85%"}}
                                        src={sign.image}
                                      />
                                    </View>
                                    <View style={{width: "50%", flexDirection: "column", fontSize: 11, paddingLeft: "15px"}}> 
                                        <Text style={{marginBottom: "10px", fontFamily: 'Helvetica'}} >Sign: {sign.name}</Text>
                                        <Text style={{marginBottom: "10px", fontFamily: 'Helvetica'}} >Quantity: {code_reference.signs_added[sign_key]}</Text>
                                        <Text style={{marginBottom: "10px", fontFamily: 'Helvetica'}} >Total Anticipated Cost Of Repair: ${((parseFloat(sign.sign_cost) + parseFloat(sign.sign_labor) ) * parseFloat(code_reference.signs_added[sign_key])).toFixed(2) }</Text>
                                    </View>  
                                </View>
                              )}
                            </View>
                            
                        )}
                      </View>
                    )}

                    {(code_reference.method == 2) && (
                      <View wrap={false}> 
                        <View style={{flexDirection: "column", paddingBottom: 10, marginTop: 20}} >
                          <Text style={{ fontSize: 11, textAlign: "center",alignSelf: "center", fontFamily: 'Helvetica' }}>Anticipated Cost Of Repair</Text>
                        </View>
                        <View style={{flexDirection: "column", fontSize: 11, paddingLeft: "15px"}}> 
                            <Text style={{marginBottom: "10px", fontFamily: 'Helvetica'}} >Measurements: {code_reference.l_ft * code_reference.w_ft }SQFT ({ code_reference.l_ft }FT Wide x { code_reference.w_ft }FT Long)</Text>
                            <Text style={{marginBottom: "10px", fontFamily: 'Helvetica'}} >Total Anticipated Cost Of Repair: ${((parseFloat(code_reference.l_ft) * parseFloat(code_reference.w_ft) ) * ( parseFloat(code_reference.labor_cost) * parseFloat(code_reference.material_cost)  ) ) .toFixed(2) }</Text>
                        </View> 

                      </View>
                    )}

                  </View>


          )}


          {(text2 != "Compliant") && (
            <View break={text2 != "Compliant"}style={styles.code_header}  >
               <View break></View>
                <View style={{text_aling: "center", width: "100%", flexDirection: "row"}}>
                  <Text id = "ANTICIPATEDCOSTSUMMARY"style={{fontSize: 11, fontWeight: "bold", fontFamily: "Helvetica-Bold"}} >Anticipated Cost Summary </Text>
                </View>
            </View>
          )}

            {s_total.map((sign,key_section1) =>
              <View style={{fontSize: 11}} > 
              {(sign.count > 0) && ( 
                <View wrap={false} > 
                <View style={{ backgroundColor: "#4EBCFC", color : "#FFFFFF", flexDirection: "row", paddingTop: "5px", paddingBottom: "5px" ,  fontSize: 11, marginTop: 5}}>
                    
                    <Text style={{width: "55%",fontSize: 11, padding: "5px", fontFamily: 'Helvetica-Bold'}}>Sign</Text>
                    <Text style={{width: "25%",fontSize: 11, padding: "5px", fontFamily: 'Helvetica-Bold'}}>Quantity</Text>
                    <Text style={{width: "20%",fontSize: 11, padding: "5px", fontFamily: 'Helvetica-Bold'}}>Total</Text>
                </View>
                
                  <View style={{flexDirection: "column", width: "100%"}}>
                    
                      <View style={{flexDirection: "row", paddingTop: "10px"}}>
                            <View style={{width: "15%"}}>                                
                              <Image
                                style={{width: "100%"}}
                                src={sign.image}
                              />
                            </View>
                            <Text style={{width: "40%",fontSize: 11, padding: "5px", fontFamily: 'Helvetica'}}>{ sign.name }</Text>
                            <Text style={{width: "25%",fontSize: 11, padding: "5px", fontFamily: 'Helvetica'}}>{sign.count}</Text>
                            <Text style={{width: "20%",fontSize: 11, padding: "5px", fontFamily: 'Helvetica'}}>${((parseFloat(sign.sign_cost) + parseFloat(sign.sign_labor) ) * parseFloat(sign.count)).toFixed(2) }</Text>
                      </View>
                   
                  </View>
                  </View>
              )}  
              </View>
            )}
            {activeSections.map((code_reference,key_section1) =>

                        <View>                            
                            
                            {(code_reference.signs_added.length > 999999) && ( 
                              <View style={{fontSize: 11}} > 
                                <View style={{flexDirection: "row", paddingTop: "10px", fontSize: 11}}>
                                    <Text style={{ width: "35%",fontSize: 11, padding: "5px", fontFamily: 'Helvetica'}}>Code Reference</Text>
                                    <Text style={{width: "30%",fontSize: 11, padding: "5px", fontFamily: 'Helvetica'}}>Sign</Text>
                                    <Text style={{width: "20%",fontSize: 11, padding: "5px", fontFamily: 'Helvetica'}}>Quantity</Text>
                                    <Text style={{width: "15%",fontSize: 11, padding: "5px", fontFamily: 'Helvetica'}}>Total</Text>
                                </View>
                                {(report?.signs || []).map((sign,sign_key) =>
                                  <View style={{flexDirection: "column", width: "100%"}}>
                                    {(code_reference.signs_added[sign_key] > 0) && ( 
                                      <View style={{flexDirection: "row", paddingTop: "10px"}}>
                                            <Text style={{width: "35%",fontSize: 11, padding: "5px", fontFamily: 'Helvetica'}}>{code_reference.reference}</Text>
                                            <Text style={{width: "30%",fontSize: 11, padding: "5px", fontFamily: 'Helvetica'}}>{ sign.name }</Text>
                                            <Text style={{width: "20%",fontSize: 11, padding: "5px", fontFamily: 'Helvetica'}}>{code_reference.signs_added[sign_key]}</Text>
                                            <Text style={{width: "15%",fontSize: 11, padding: "5px", fontFamily: 'Helvetica'}}>${((parseFloat(sign.sign_cost) + parseFloat(sign.sign_labor) ) * parseFloat(code_reference.signs_added[sign_key])).toFixed(2) }</Text>
                                      </View>
                                    )}
                                  </View>
                                )}
                              </View>
                            )}

                            {(code_reference.method == 2) && ( 
                              <View style={{fontSize: 11}} > 
                                <View style={{flexDirection: "row", paddingTop: "10px", fontSize: 11}}>
                                    <Text style={{width: "35%",fontSize: 11, padding: "5px", fontFamily: 'Helvetica-Bold'}}>Code Reference</Text>
                                    <Text style={{width: "30%",fontSize: 11, padding: "5px", fontFamily: 'Helvetica-Bold'}}>Sign</Text>
                                    <Text style={{width: "20%",fontSize: 11, padding: "5px", fontFamily: 'Helvetica-Bold'}}>Measurement</Text>
                                    <Text style={{width: "15%",fontSize: 11, padding: "5px", fontFamily: 'Helvetica-Bold'}}>Total</Text>
                                </View>
                                <View style={{flexDirection: "row", paddingTop: "10px"}}>
                                      <Text style={{width: "35%",fontSize: 11, padding: "5px", fontFamily: 'Helvetica'}}>{code_reference.reference}</Text>
                                      <Text style={{width: "30%",fontSize: 11, padding: "5px", fontFamily: 'Helvetica'}}>Not Applicable</Text>
                                      <Text style={{width: "20%",fontSize: 11, padding: "5px", fontFamily: 'Helvetica'}}>{code_reference.l_ft * code_reference.w_ft }SQFT</Text>
                                      <Text style={{width: "15%",fontSize: 11, padding: "5px", fontFamily: 'Helvetica'}}>${((parseFloat(code_reference.l_ft) * parseFloat(code_reference.w_ft) ) * ( parseFloat(code_reference.labor_cost) * parseFloat(code_reference.material_cost)  ) ) .toFixed(2) }</Text>
                                </View>
                              </View>
                            )} 

                        </View>
                      
            )}

          </View>
          <View fixed  style={styles.pageNumber1}> 
              <Link src='#Tableofcontents'>
              <Text style={styles.linkText} >Table Of Contents</Text>
              </Link>
            </View> 
            
            <Text style={styles.pageNumber2} render={({ pageNumber, totalPages }) => (
                `${pageNumber} `
            )} fixed />
            <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
                '© Arcor Inc' 
                 
            )} fixed />
          </Page>

     

    </Document>
    );
  };

  if(sections.length > 0){ 
    //ReactDOM.render(<App />, document.getElementById('root'));
  } 

  if (redirctTo_all){
    return <Redirect to='/admin/reports'  />
  }

  // Function to generate dynamic filename
  const generateFileName = (report) => {
    // Check if report attribute exists and use it for filename
    if (report.report_name && text2) {
      // Return the exact filename without any modifications
      return `${report.report_name} (${text2}) Report.pdf`;
    }
    // Default filename if report attribute is not available
    return 'report.pdf';
  };

  const showNotification = place => {
    setTC(true);
    setTimeout(function() {
      setTC(false);
    }, 3000);
  };


  
  
  return (
    <div>
      {/* CSS Animation for spinner */}
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>

      <Snackbar
        place="tc"
        color="rose"
        icon={AddAlert}
        message={Errmessage}
        open={tc}
        closeNotification={() => setTC(false)}
        close
      />

      {pdfCacheError && (
        <Snackbar
          place="tc"
          color="danger"
          icon={AddAlert}
          message={pdfCacheError}
          open={!!pdfCacheError}
          closeNotification={() => setPdfCacheError("")}
          close
        />
      )}

      {/* PDF Generation Loader Modal */}
      {isLoadingCachedPdf && pdfGenerationStatus && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999,
          backdropFilter: 'blur(4px)'
        }}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '16px',
            padding: '40px',
            maxWidth: '500px',
            width: '90%',
            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
            textAlign: 'center'
          }}>
            {/* Animated spinner */}
            <div style={{
              width: '80px',
              height: '80px',
              margin: '0 auto 24px',
              border: '4px solid #f3f3f3',
              borderTop: '4px solid #224B8B',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite'
            }}></div>

            {/* Title */}
            <Typography variant="h6" style={{
              marginBottom: '16px',
              fontWeight: 600,
              color: '#333'
            }}>
              Generating PDF Report
            </Typography>

            {/* Status message */}
            <Typography variant="body1" style={{
              marginBottom: '24px',
              color: '#666',
              fontSize: '14px'
            }}>
              {pdfGenerationStatus || 'Please wait...'}
            </Typography>

            {/* Progress bar */}
            <div style={{
              width: '100%',
              height: '8px',
              backgroundColor: '#f0f0f0',
              borderRadius: '4px',
              overflow: 'hidden',
              marginBottom: '12px'
            }}>
              <div style={{
                height: '100%',
                backgroundColor: '#224B8B',
                borderRadius: '4px',
                transition: 'width 0.3s ease',
                width: `${pdfGenerationProgress}%`
              }}></div>
            </div>

            {/* Progress percentage */}
            <Typography variant="body2" style={{
              color: '#224B8B',
              fontWeight: 600,
              marginBottom: '8px'
            }}>
              {pdfGenerationProgress}% Complete
            </Typography>

            {/* Helper text */}
            <Typography variant="caption" style={{
              color: '#999',
              display: 'block',
              marginTop: '16px'
            }}>
              This may take a few moments for large reports
            </Typography>
          </div>
        </div>
      )}

      {/* Progress Bar */}
      {showProgress && (
        <Box sx={{ width: '100%', mb: 2, position: 'sticky', top: 0, zIndex: 1000, backgroundColor: '#fff', padding: 2, boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
          <Box display="flex" alignItems="center">
            <Box width="100%" mr={1}>
              <LinearProgress 
                variant="determinate" 
                value={processingProgress} 
                style={{ height: 8, borderRadius: 4 }}
              />
            </Box>
            <Box minWidth={35}>
              <Typography variant="body2" color="textSecondary">
                {processingProgress}%
              </Typography>
            </Box>
          </Box>
          <Typography variant="body2" color="textPrimary" style={{ marginTop: 8 }}>
            {processingStatus}
          </Typography>
        </Box>
      )}
      
      <GridContainer>

      <GridItem xs={12} sm={3} md={3}>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {(r_type == 2) && (
                <a  href={'/admin/report/' + id + "/1"} >
                  <Button color="rose">
                    View Compliant Report
                  </Button>
                </a>
              )}
              {(r_type == 1) && (
              <a  href={'/admin/report/' + id+ "/2"} >
                <Button color="rose">
                  View Non-Compliant Report
                </Button>
              </a>
               )}

          </div>
        </GridItem>

        <GridItem xs={12} sm={9} md={9}>

          <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap', justifyContent: 'flex-end' }}>
                  <a target="_blank" href={'/admin/images/' + id} >
                    <Button color="rose">
                        View Images
                    </Button>
                  </a>

                  <Button
                    onClick={handleViewCachedPDF}
                    color="primary"
                    disabled={isLoadingCachedPdf}
                    style={{ minWidth: '163px' }}
                  >
                    {isLoadingCachedPdf ? 'Loading...' : 'View Cached PDF'}
                  </Button>


                  <Button onClick={(e)=>setRedirctTo_all(true)} style={{ minWidth: '186px' }} color="primary">
                      Back to All Reports
                  </Button>
                  {/* <Button
                    onClick={handleDownloadCachedPDF}
                    color="info"
                    disabled={isLoadingCachedPdf}
                    style={{ minWidth: '150px' }}
                  >
                    {isLoadingCachedPdf ? 'Loading...' : 'Download PDF'}
                  </Button> */}

                  <Button
                    onClick={handleDeleteAndRegeneratePDF}
                    color="warning"
                    disabled={isLoadingCachedPdf}
                    style={{ minWidth: '214px' }}
                  >
                    {isLoadingCachedPdf ? 'Loading...' : 'Delete & Regenerate PDF'}
                  </Button>
             
            </div>
        </GridItem>

        {/* <GridItem xs={12} sm={12} md={12}>
          <div className={classes.right}>
          </div>
        </GridItem> */}
          
        <GridItem xs={12} sm={12} md={12}>

            
            
          <Card>

                {sections?.length > 0?  (
                  <div>
                  {showCachedPdf && cachedPdfUrl ? (
                    <div style={{position: "relative"}}>
                      <div style={{marginRight: "5px", textAlign: "right", display: "flex", justifyContent: "flex-end", gap: "5px"}}>
                        <Button
                          size="sm"
                          color="info"
                          disabled={isLoadingCachedPdf}
                          onClick={handleDownloadCachedPDF} style={{ minWidth: '83px' }}
                        >
                          {isLoadingCachedPdf ? 'Loading...' : 'Download PDF'}
                        </Button>
                        <Button
                          size="sm"
                          color="secondary"
                          onClick={() => setShowCachedPdf(false)}
                        >
                          Hide PDF
                        </Button>
                      </div>
                      <iframe
                        src={`${cachedPdfUrl}#toolbar=0`}
                        style={{width: "100%", height: "1200px", border: "1px solid #ddd"}}
                        title="Cached PDF Report"
                      />
                    </div>
                  ) : (
                    <div style={{padding: "20px", textAlign: "center"}}>
                      <p>Click "View Cached PDF" to display the cached PDF here, "Download PDF" to download it, or "Delete & Regenerate PDF" if the underlying data has changed.</p>
                    </div>
                  )}
                  </div> 
                ):<div><p className="text-danger">The report seems to have no visible sections</p></div>}
            
          </Card>

        </GridItem>
      </GridContainer>
    </div>
    
  );
}
